import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { FormArray, FormBuilder, FormControl, UntypedFormGroup, ValidatorFn, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastService } from "@core/components/toasts/toasts.service";
import { FileService } from "@core/services/file.service";
import { NgbDropdown, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogComponent } from "app/layout/components/confirm-dialog/confirm-dialog.component";
import { FormAbstact } from "app/views/pages/abstract/form-abstract";
import { WorkforcePlanModalComponent } from "app/views/pages/workforce-plan/components/workforce-plan-modal/workforce-plan-modal.component";
import { FeedbackFormComponent, FeedbackFormMode } from "app/views/shared/feedback/components/feedback-form/feedback-form.component";
import moment from "moment-business-days";
import { CustomValidators } from "ng2-validation";
import { EmployeeService } from "services/corporate/employee.service";
import { ApprovalScopeService } from "services/corporate/approval-scope.service";
import { DomainService } from "services/domain.service";
import FeatureFlagEnum from "services/enums/featureFlag.enum";
import { ApprovalScopeActionType } from "services/enums/approvalScopeActionType.enum";
import { MovementRequestRaiseType } from "services/enums/MovementRequestRaiseType.enum";
import { UnhealthinessType } from "services/enums/UnhealthinessType.enum";
import { WorkforceplanEmployeeStatusType } from "services/enums/WorkforceplanEmployeeStatusType.enum";
import { WorkforceplanMovementType } from "services/enums/WorkforceplanMovementType.enum";
import { JobTitleService } from "services/hiring/jobTitle.service";
import { TimeShiftService } from "services/hiring/timeShift.service";
import { TimeShiftModel } from "services/models/hiring/timeShift.model";
import { OptionModel } from "services/models/model";
import {
	WorkforcePlanTeamEmployeeModel,
} from "services/models/workforceplan";
import { WorkforcePlanSolicitationStepModel } from "services/models/workforceplan/workforceplan-solicitation.model";
import { WorkforcePlanDrawerEmployeeService } from "services/workforceplan/workforceplan-employee.service";
import { WorkforceplanService } from "services/workforceplan/workforceplan-main.service";
import { ConvertAptitudeTrainingResult } from "services/models/workforceplan/convert-aptitude-training.model";
import { WorkforceplanMovementRequestService } from "services/workforceplan/workforceplan-movement-request.service";
import { WorkforceplanMovementTypeService } from "services/workforceplan/workforceplan-movement-type.service";
import { WorkforceplanTrainingService } from "services/workforceplan/workforceplan-training.service";
import { formattedPhone, guidEmpty } from "utils/helps";
import {
	DrawerDataInput,
	DrawerStatus,
	ISolicitationFormComponent,
	FormRequestDisciplinaryMeasure,
	FormRequestDisciplinaryMeasurePayload,
	FormFeedback,
	FormFeedbackPayload,
	FormRequestHiringIncreasePayload,
	FormRequestHiringIncreaseValues,
	FormRequestHiringSubstitutionPayload,
	FormRequestHiringSubstitutionValues,
	FormRequestHiringReplacementValues,
	FormRequestHiringReplacementPayload,
	NewRecruitmentEmployee,
	RequestTrainingPayload,
	RequestTrainingValues,
	RequestAptitudeTrainingPayload,
	RequestAptitudeTrainingValues,
	SolicitationUpdateStatusData,
	FormRequestDismissalValues,
	FormRequestDismissalPayload,
	DrawerType,
} from './form-types';
import { formatSalaryForIntegration, normalizeSalaryValue } from '@core/utils/currency-value.helper';
import { JustificationOccurrenceDisciplinaryMeasure } from "services/enums/JustificationOccurrenceDisciplinaryMeasure.enum";
import { TypeOccurrenceDisciplinaryMeasure } from "services/enums/TypeOccurrenceDisciplinaryMeasure.enum";
import { AuthService } from "services/auth.service";
import { HierarchyLeaderService } from "services/corporate/hierarchyLeader.service";
import { EmployeeModel } from "services/models/employee.model";
import { QueryParams } from "services/models/odata/queryParams";
import { Filter } from "services/models/odata/filter";
import { JobTitleModel } from "services/models/hiring/jobTitle.model";
import { JobTitleGroupService } from "services/hiring/jobTitleGroup.service";
import { pagesActions } from "app/page-access";
import { ApprovalScopeCustomFieldModel } from "services/models/corporate/approval-scope/approval-scope-custom-field.model";
import { ApprovalScopeStepInstructionsContextModel } from "services/models/corporate/approval-scope/approval-scope-step-instructions-context.model";
import {
	handleMovementRequestCommandOutcome,
} from "app/views/shared/helpers/standard-field-validation.helper";
import { MovementRequestFileModel } from "services/models/workforceplan/movement-request-file.model";
import { FileContentModel } from "services/models/fileContent";
import { Subject, Subscription } from "rxjs";
import { take, takeUntil } from "rxjs/operators";

type ListsOptions = {
	jobTitleOptions?: OptionModel[];
	hiringTypeOptions?: OptionModel[];
	timeShiftsOptions?: TimeShiftModel[];
	centerCostsOptions?: OptionModel[];
	jobTitleGroupOptions?: OptionModel[];
	resignationTypesOptions?: OptionModel[];
	employeesResignationsOptions?: NewRecruitmentEmployee[];
	trainedEmployeeOptions?: NewRecruitmentEmployee[];
	tradeUnionsOptions?: OptionModel[];
	employeesInWorkScaleGroup?: WorkforcePlanTeamEmployeeModel[];
	activeEmployees?: WorkforcePlanTeamEmployeeModel[];
	currentCenterCostsOptions?: OptionModel[];
	currentJobTitleOptions?: OptionModel[];
	nextMovementTypesOptions?: OptionModel[];
	movementTypeOptions?: OptionModel[];
	jobTitles?: JobTitleModel[];
	workScaleGroupOptions?: OptionModel[];
}

enum MovementStatusType {
	NONE = 0,
	PENDING = 1,
	APPROVED = 2,
	REJECTED = 3,
	CANCELED = 4
}

import { disableHiddenStandardControls, isStandardFieldHidden } from "./standard-field-visibility.helper";
@Component({
	selector: "app-shared-drawer-workforceplan-solicitation",
	templateUrl: "./workforce-plan-drawer-team-solicitation.component.html",
	styleUrls: ["./workforce-plan-drawer-team-solicitation.component.scss"],
})
export class AppSharedDrawerWorkforceplanSolicitationComponent extends FormAbstact<WorkforcePlanTeamEmployeeModel, WorkforcePlanDrawerEmployeeService> implements OnInit, OnChanges {
	private _data: DrawerDataInput | null = null;

	@Input()
	set data(value: DrawerDataInput | null) {
		this._data = value;
		if (value?.type != null && this._initialized) {
			this.initializeForm();
		}
	}
	get data(): DrawerDataInput | null {
		return this._data;
	}

	private _initialized = false;

	@Input() source: "action-required" | null = null;

	@Output() onSuccess = new EventEmitter();

	@Output() handleClose = new EventEmitter();

	@ViewChild("feedbackList") feedbackListComponent: any;

	@ViewChild("actionsDropdown", { read: NgbDropdown }) actionsDropdown: NgbDropdown;

	@ViewChild("solicitationFormRef") solicitationFormRef: ISolicitationFormComponent | undefined;

	public lists: ListsOptions = {};

	public trainingOptions: OptionModel[] = [];

	public drawerTitle = "";

	public drawerStatus: DrawerStatus = "loading";
	public showOpeningInstructionsBanner = false;
	public openingInstructionsText = '';
	public openingInstructionsApprovalScopeId = '';
	public openingInstructionsCanHidePreference = false;
	public canChangeToDifferentCostCenter = true;
	public openingInstructionsContextFailed = false;
	public readonly openingContextFailureMessage =
		"Não foi possível validar as regras do fluxo. A solicitação de troca de centro de custo fica bloqueada até recarregar.";
	public showStepInstructionsBanner = false;
	public stepInstructionsText = '';

	public MovementType = WorkforceplanMovementType

	public isSubmittingForm = false;
	private _formWasEnabledBeforeConversion = false;
	private _convertPreviewSubscription?: Subscription;
	private _convertRequestSubscription?: Subscription;
	private readonly destroy$ = new Subject<void>();
	private _initializeFormRunId = 0;
	private _openingContextRequestId = 0;
	public loadingFileIds = new Set<string>();
	public customFieldsLoading = false;
	public hiddenStandardFields: string[] = [];
	public customFieldsForm: UntypedFormGroup = this._formBuilder.group({
		customFields: this._formBuilder.array([])
	});

	/** True while cost-center-change form is fetching employee (details mode). Used to show loading in employee block. */
	public isEmployeeLoading = false;

	public justification = "";

	public DrawerTypes = {
		SHIFT_CHANGE: "SHIFT_CHANGE",
		// JOBTITLE_CHANGE: "JOBTITLE_CHANGE",
		REQUEST_TRAINING: "REQUEST_TRAINING",
		REQUEST_APTITUDE_TRAINING: "REQUEST_APTITUDE_TRAINING",
		EMPLOYEE_DETAILS: "EMPLOYEE_DETAILS",
		REQUEST_DISMISSAL: "REQUEST_DISMISSAL",
		COST_CENTER_AND_JOB_TITLE_CHANGE: "COST_CENTER_AND_JOB_TITLE_CHANGE",
		REQUEST_HIRING_INCREASE: "REQUEST_HIRING_INCREASE",
		REQUEST_HIRING_SUBSTITUTION: "REQUEST_HIRING_SUBSTITUTION",
		REQUEST_HIRING_REPLACEMENT: "REQUEST_HIRING_REPLACEMENT",
		REQUEST_PROMOTION: "REQUEST_PROMOTION",
		SOLICITATION_DETAILS: 'SOLICITATION_DETAILS',
		REQUEST_WORK_FORCEPLAN: 'REQUEST_WORK_FORCEPLAN',
		REQUEST_DISCIPLINARY_MEASURE: 'REQUEST_DISCIPLINARY_MEASURE',
		REQUEST_FEEDBACK: 'REQUEST_FEEDBACK'
	};

	private minDate = moment().add(1, "d").format("yyyy-MM-DD");

	public unhealthinessOptions = UnhealthinessType.buildListEnum();

	public occurrenceTypeDisciplinaryMeasureOptions = TypeOccurrenceDisciplinaryMeasure.buildListEnum();

	public justificationOccurrenceDisciplinaryMeasureOptions = JustificationOccurrenceDisciplinaryMeasure.buildListEnum();

	drawerRequestState: boolean = false;
	requestFeedback: EmployeeModel = new EmployeeModel();

	drawerViewState: boolean = false;

	public employeeDetailsActiveTab: 'registration' | 'feedbacks' | 'salaryHistory' | 'disciplinaryMeasure' = 'registration';
	public canViewSensitiveEmployeeDetailsTabs = false;

	public get usesEmployeeFeedbacks(): boolean {
		return this._domainService.featureFlag.hasEnabled(FeatureFlagEnum.UsesEmployeeFeedbacks);
	}

	constructor(
		router: Router,
		service: WorkforcePlanDrawerEmployeeService,
		activeRoute: ActivatedRoute,
		toasterService: ToastService,
		private _formBuilder: FormBuilder,
		private _employeeService: EmployeeService,
		private _jobTitleService: JobTitleService,
		private _jobTitleGroupService: JobTitleGroupService,
		private _timeShiftService: TimeShiftService,
		private _domainService: DomainService,
		private _workforceplanService: WorkforceplanService,
		private _workforceplanMovementRequestService: WorkforceplanMovementRequestService,
		private _modalService: NgbModal,
		private _trainingService: WorkforceplanTrainingService,
		private _movementTypeService: WorkforceplanMovementTypeService,
		private _authService: AuthService,
		private _approvalScopeService: ApprovalScopeService,
		private _fileService: FileService,
		private _hierarchyLeaderService: HierarchyLeaderService,
	) {
		super(service, activeRoute, router, toasterService);
	}

	ngOnInit() {
		this._initialized = true;
		if (this.data?.type != null) {
			this.initializeForm();
		} else {
			this.drawerStatus = "loading";
			this.drawerTitle = "Carregando...";
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		const dataChange = changes["data"];
		if (dataChange && !dataChange.firstChange && this.data?.type != null) {
			this.initializeForm();
		}
	}

	ngOnDestroy() {
		this._convertPreviewSubscription?.unsubscribe();
		this._convertRequestSubscription?.unsubscribe();
		this.destroy$.next();
		this.destroy$.complete();
	}

	public handleCancel() {
		this.handleClose.emit();
	}

	public setEmployeeDetailsTab(tab: 'registration' | 'feedbacks' | 'salaryHistory' | 'disciplinaryMeasure'): void {
		if (tab === 'feedbacks' && !this.usesEmployeeFeedbacks) {
			return;
		}
		if ((tab === 'feedbacks' || tab === 'salaryHistory' || tab === 'disciplinaryMeasure') && !this.canViewSensitiveEmployeeDetailsTabs) {
			return;
		}
		this.employeeDetailsActiveTab = tab;
	}

	public handleCreateView(obj?: EmployeeModel): void {
		this.requestFeedback = obj ?? this.requestFeedback;
		const modalRef = this._modalService.open(FeedbackFormComponent, {
			animation: false,
			windowClass: "feedback-form-drawer-modal",
			backdrop: "static",
			keyboard: true,
			size: "xl",
		});
		modalRef.componentInstance.mode = FeedbackFormMode.Create;
		modalRef.componentInstance.requestFeedback = this.requestFeedback;
		modalRef.componentInstance.data = this.data;
		modalRef.componentInstance.organicFeedback = true;
		modalRef.result.then(
			(result: boolean) => {
				if (result) this.feedbackListComponent?.loadFeedbacks();
			},
			(reason: boolean) => {
				if (reason) this.feedbackListComponent?.loadFeedbacks();
			}
		);
	}

	onCancel(loadRequests?: boolean) {
		this.drawerRequestState = undefined;
		this.drawerViewState = undefined;
		if (loadRequests) this.feedbackListComponent?.loadFeedbacks();
	}

	onEmployeeLoadingChange(loading: boolean): void {
		setTimeout(() => {
			this.isEmployeeLoading = loading;
		}, 0);
	}

	private getCurrentForm(): UntypedFormGroup | undefined {
		return this.solicitationFormRef?.getForm() ?? this.form;
	}

	private applyHiddenStandardFields(): void {
		disableHiddenStandardControls(this.getCurrentForm(), this.hiddenStandardFields);
	}

	public isStandardFieldHidden(fieldKey: string): boolean {
		return isStandardFieldHidden(this.hiddenStandardFields, fieldKey);
	}

	private getCurrentPayload(): { id?: string;[key: string]: unknown } {
		return this.solicitationFormRef ? this.solicitationFormRef.getPayload() : this._getPayload();
	}

	private getCurrentUpdatePayload(): string | undefined {
		return this.solicitationFormRef?.getUpdatePayload?.() ?? this._getPayloadUpdateSolicitation();
	}

	public handleSubmit() {
		if (this.openingInstructionsContextFailed) {
			this.toasterAbstract.showWarning(this.openingContextFailureMessage);
			return;
		}

		if (this.data?.mode === "add" && this.warnIfSameAptitudeTrainingJobTitle()) {
			return;
		}

		const formToValidate = this.getCurrentForm();

		if (!formToValidate?.valid || this.hasInvalidEditableCustomFields()) {
			if (formToValidate) {
				Object.keys(formToValidate.controls).forEach((key) => {
					formToValidate.get(key)?.markAsDirty();
					formToValidate.get(key)?.markAsTouched();
				});
			}
			this.customFieldsForm.markAllAsTouched();
			this.checkForm();
			return;
		}

		try {
			this.isSubmittingForm = true;

			const payload = this.getCurrentPayload();
			payload.customFields = this.getCustomFieldsPayload();

			if (this.data.mode === 'details') {
				payload.id = this.data.solicitation.id;
			}

			const method = payload.id ? 'updateMovementRequest' : 'createMovementRequest'

			this._service[method](this.data.workforcePlanId, payload).subscribe(
				(response) => {
					handleMovementRequestCommandOutcome({
						response,
						toast: this.toasterAbstract,
						onSuccess: () => {
							this.toasterAbstract.showSuccess("Solicitação realizada com sucesso.");
							this.isSubmittingForm = false;

							if (this.vacancyReplacement) {
								this.initializeAutomaticRequest(payload);
							} else {
								this.onSuccess.emit();
							}
						},
						onBlocked: () => {
							this.isSubmittingForm = false;
						},
					});
				},
				(error) => {
					handleMovementRequestCommandOutcome({
						error,
						toast: this.toasterAbstract,
						onSuccess: () => {},
						onBlocked: () => {
							this.isSubmittingForm = false;
						},
						blockedFallbackMessage: 'Não foi possível realizar a solicitação. Verifique a causa e tente novamente.',
					});
				}
			);
		} catch (error) {
			console.error(error);

			this.toasterAbstract.showError("Ocorreu um erro inesperado");

			this.isSubmittingForm = false;
		}
	}

	public checkForm() {
		const invalidControls: { controlName: string, errors: any }[] = [];

		// Helper function to recursively check form controls
		const findInvalidControls = (formGroup: UntypedFormGroup, parentPath = '') => {
			Object.keys(formGroup.controls).forEach(key => {
				const control = formGroup.get(key);
				control?.markAsDirty();
				control?.markAsTouched();
				const currentPath = parentPath ? `${parentPath}.${key}` : key;

				if (control instanceof UntypedFormGroup) {
					findInvalidControls(control, currentPath);
				} else if (control?.invalid) {
					invalidControls.push({
						controlName: currentPath,
						errors: control.errors
					});
				}
			});
		};

		const formToValidate = this.getCurrentForm();
		if (formToValidate) {
			findInvalidControls(formToValidate);
		}

		const customFieldsArray = this.customFieldsArray;
		customFieldsArray.controls.forEach((control, index) => {
			control.markAllAsTouched();
			if (control.invalid) {
				invalidControls.push({
					controlName: `customFields.${index}`,
					errors: control.errors,
				});
			}
		});

		return invalidControls;
	}

	async initializeAutomaticRequest(payload: any) {
		if (!this.vacancyReplacement) return;

		if (this.vacancyReplacement === WorkforceplanMovementType.NEW_HIRING_SUBSTITUTION.value) {
			this.data.type = this.DrawerTypes.REQUEST_HIRING_SUBSTITUTION as any;

			const expectedDate = this.getCurrentForm()?.get("expectedDate")?.value;

			await this.initializeForm();

			const employee = this.data.employee as any;

			const obj = {
				id: employee.id,
				jobTitleId: employee.jobTitleId,
				jobTitleName: employee.jobTitleName,
				name: employee.name,
				registration: employee.registration,
				resignationDate: payload.effectiveDate,
				timeshiftId: employee.timeShiftId,
				timeshiftTitle: employee.timeShiftTitle,
			} as NewRecruitmentEmployee;

			this.form.get("employee").setValue(obj);
			this.form.get("employeeId").setValue(this.data.employee.id);
			this.form.get("deadline").setValue(expectedDate);
			this.form.get("jobTitleId").setValue(obj.jobTitleId);
			this.form.get("timeShiftId").setValue(obj.timeshiftId);

			return;
		}

		this.data.type = (this.vacancyReplacement === WorkforceplanMovementType.TRAINNING.value ? this.DrawerTypes.REQUEST_TRAINING :
			this.vacancyReplacement === WorkforceplanMovementType.COST_CENTER_AND_JOB_TITLE_CHANGE.value ? this.DrawerTypes.COST_CENTER_AND_JOB_TITLE_CHANGE :
				this.data.type) as any;
		this.data.hasSubType = true;

		const employee = this.data.employee as any;
		this.data.costCenterId = this.data.costCenterId || employee.centerCostId || employee.costCenterId;
		this.data.costCenterName = this.data.costCenterName || employee.costCenterName;
		this.data.replacedEmployeeId = employee.id;
		const obj = {
			id: guidEmpty,
			jobTitleId: employee.jobTitleId,
			jobTitleName: employee.jobTitleName,
			jobTitleGroupId: employee.jobTitleGroupId,
			jobTitleGroupName: employee.jobTitleGroupName,

		} as WorkforcePlanTeamEmployeeModel;

		this.data.employee = Object.assign({}, obj);

		await this.initializeForm();

		if (this.data.type === 'REQUEST_TRAINING') {
			this.form.get("jobTitleGroupId").setValue(employee.jobTitleGroupId);
			this.form.get("jobTitleId").setValue(employee.jobTitleId);
			return;
		}
	}

	public handleSubmitDecline() {
		this.actionsDropdown?.close();

		this.isSubmittingForm = true;

		const payload = this._getPayloadUpdateStatusSolicitation(MovementStatusType.REJECTED);

		this._workforceplanService.postWorkforcePlanSolicitationUpdateStatus(payload.movementRequestId, payload).subscribe({
			next: (response) => {
				handleMovementRequestCommandOutcome({
					response,
					toast: this.toasterAbstract,
					onSuccess: () => {
						this.toasterAbstract.showSuccess("Solicitação de movimentação recusada com sucesso.");
						this.isSubmittingForm = false;
						this.onSuccess.emit({ shouldRefetch: true });
					},
					onBlocked: () => {
						this.isSubmittingForm = false;
					},
					blockedFallbackMessage: 'Não foi possível recusar a solicitação. Verifique a causa e tente novamente.',
				});
			},
			error: (error) => {
				handleMovementRequestCommandOutcome({
					error,
					toast: this.toasterAbstract,
					onSuccess: () => {},
					onBlocked: () => {
						this.isSubmittingForm = false;
					},
					blockedFallbackMessage: 'Não foi possível recusar a solicitação. Verifique a causa e tente novamente.',
				});
			},
		});
	}

	public isCancellationFormOpen = false;
	public cancellationReason = "";

	/** Solicitante pode cancelar enquanto a solicitação estiver pendente (quando habilitado nas configurações). */
	public get canCancelSolicitation(): boolean {
		return this.data?.mode === "details" && !!this.data?.solicitationDetails?.canCancel;
	}

	public get isSolicitationCanceled(): boolean {
		return !!this.data?.solicitationDetails?.canceledAt;
	}

	public openCancellationForm(): void {
		this.cancellationReason = "";
		this.isCancellationFormOpen = true;
	}

	public closeCancellationForm(): void {
		this.isCancellationFormOpen = false;
		this.cancellationReason = "";
	}

	public handleSubmitCancellation(): void {
		const movementRequestId = this.data?.solicitation?.id;
		const reason = this.cancellationReason?.trim();
		if (!movementRequestId || this.isSubmittingForm) return;

		if (!reason) {
			this.toasterAbstract.showWarning("Informe o motivo do cancelamento.");
			return;
		}

		this.isSubmittingForm = true;
		this._workforceplanMovementRequestService
			.cancelMovementRequest(movementRequestId, reason)
			.pipe(takeUntil(this.destroy$), take(1))
			.subscribe({
				next: (response) => {
					handleMovementRequestCommandOutcome({
						response,
						toast: this.toasterAbstract,
						onSuccess: () => {
							this.isSubmittingForm = false;
							this.closeCancellationForm();
							this.toasterAbstract.showSuccess("Solicitação cancelada com sucesso.");
							this.onSuccess.emit({ shouldRefetch: true });
						},
						onBlocked: () => {
							this.isSubmittingForm = false;
						},
						blockedFallbackMessage: "Não foi possível cancelar a solicitação.",
					});
				},
				error: (error) => {
					handleMovementRequestCommandOutcome({
						error,
						toast: this.toasterAbstract,
						onSuccess: () => {},
						onBlocked: () => {
							this.isSubmittingForm = false;
						},
						blockedFallbackMessage: "Não foi possível cancelar a solicitação.",
					});
				},
			});
	}

	public get canConvertAptitudeTraining(): boolean {
		// hotfix/4080: oculta conversão de aptidão → treinamento padrão
		return false;
	}

	public get conversionLinkMessage(): string {
		const fromId = this.data?.solicitationDetails?.convertedFromMovementRequestId
			|| this.data?.solicitation?.convertedFromMovementRequestId;
		const toId = this.data?.solicitationDetails?.convertedToMovementRequestId
			|| this.data?.solicitation?.convertedToMovementRequestId;

		if (toId) {
			return `Esta solicitação foi convertida para o treinamento padrão.`;
		}

		if (fromId) {
			return `Esta solicitação foi gerada a partir de um treinamento de aptidão.`;
		}

		return '';
	}

	public handleConvertAptitudeToInternalTraining() {
		this.actionsDropdown?.close();

		const movementRequestId = this.data?.solicitation?.id;
		if (!movementRequestId || !this.canConvertAptitudeTraining || this.isSubmittingForm) {
			return;
		}

		this._blockDrawerForConversion();

		this._convertPreviewSubscription?.unsubscribe();
		this._convertPreviewSubscription = this._workforceplanMovementRequestService
			.getConvertAptitudeTrainingPreview(movementRequestId)
			.pipe(takeUntil(this.destroy$), take(1))
			.subscribe({
				next: (preview) => {
					if (!preview?.canConvert) {
						this._unblockDrawerAfterConversion();
						this.toasterAbstract.showWarning(preview?.message || 'Não é possível converter esta solicitação.');
						return;
					}

					const modalRef = this._modalService.open(ConfirmDialogComponent, {
						backdrop: 'static',
						keyboard: false,
					});

					const previewMessage = preview?.message?.trim()
						|| 'Serão pré-aprovadas as etapas equivalentes no treinamento padrão.';
					modalRef.componentInstance.title = 'Converter para Treinamento Padrão';
					modalRef.componentInstance.message =
						`${previewMessage} A solicitação de aptidão será recusada com motivo de conversão. Deseja continuar?`;
					modalRef.componentInstance.messageConfirm = 'Converter';
					modalRef.componentInstance.messageCancel = 'Cancelar';

					modalRef.result
						.then((confirmed: boolean) => {
							if (confirmed) {
								this._executeConvertAptitudeToInternalTraining(movementRequestId);
							} else {
								this._unblockDrawerAfterConversion();
							}
						})
						.catch(() => this._unblockDrawerAfterConversion());
				},
				error: () => {
					this._unblockDrawerAfterConversion();
					this.toasterAbstract.showError('Não foi possível carregar o resumo da conversão.');
				},
			});
	}

	private _blockDrawerForConversion() {
		this.isSubmittingForm = true;
		this._formWasEnabledBeforeConversion = !!this.form && this.form.enabled;
		if (this._formWasEnabledBeforeConversion) {
			this.form.disable();
		}
	}

	private _unblockDrawerAfterConversion() {
		this.isSubmittingForm = false;
		if (this._formWasEnabledBeforeConversion) {
			this.form?.enable();
			this._formWasEnabledBeforeConversion = false;
		}
	}

	private _executeConvertAptitudeToInternalTraining(movementRequestId: string) {
		this.isSubmittingForm = true;

		// Cancela requisição anterior ainda pendente antes de refazer a chamada.
		this._convertRequestSubscription?.unsubscribe();
		this._convertRequestSubscription = this._workforceplanMovementRequestService
			.convertAptitudeTrainingToInternalTraining(movementRequestId)
			.pipe(takeUntil(this.destroy$), take(1))
			.subscribe({
				next: (result) => {
					handleMovementRequestCommandOutcome({
						response: result,
						toast: this.toasterAbstract,
						onSuccess: async () => {
							this.toasterAbstract.showSuccess('Solicitação convertida para treinamento padrão com sucesso.');
							await this._openConvertedInternalTraining(result?.createdMovementRequestId);
							this._unblockDrawerAfterConversion();
						},
						onBlocked: () => {
							this._unblockDrawerAfterConversion();
						},
						blockedFallbackMessage: 'Não foi possível converter a solicitação. Verifique a causa e tente novamente.',
					});
				},
				error: (error) => {
					handleMovementRequestCommandOutcome({
						error,
						toast: this.toasterAbstract,
						onSuccess: () => {},
						onBlocked: () => {
							this._unblockDrawerAfterConversion();
						},
						blockedFallbackMessage: 'Não foi possível converter a solicitação. Verifique a causa e tente novamente.',
					});
				},
			});
	}

	private async _openConvertedInternalTraining(createdMovementRequestId?: string) {
		if (!createdMovementRequestId || !this.data?.workforcePlanId) {
			this.onSuccess.emit({ shouldRefetch: true });
			return;
		}

		try {
			const solicitations = await this._workforceplanMovementRequestService
				.getWorkforcePlanSolicitationById(this.data.workforcePlanId, createdMovementRequestId)
				.toPromise();
			const created = solicitations?.[0];
			if (!created) {
				this.onSuccess.emit({ shouldRefetch: true });
				return;
			}

			this.data = {
				...this.data,
				type: this.DrawerTypes.REQUEST_TRAINING as DrawerType,
				mode: 'details',
				solicitation: created,
				solicitationDetails: null,
			};

			await this.initializeForm();
			this._workforceplanMovementRequestService.emitEventUpdateStateScreenActions({
				shouldRefetchCountSolicition: true,
			});
			this.onSuccess.emit({ shouldRefetch: true });
		} catch {
			this.onSuccess.emit({ shouldRefetch: true });
		}
	}

	public handleSubmitApprove() {
		this.actionsDropdown?.close();

		if (this.isTrainingCompletionBlocked) {
			this.toasterAbstract.showWarning(
				this.trainingCompletionBlockMessage
					|| 'Ainda não está no prazo para aprovar a solicitação de treinamento.'
			);
			return;
		}

		this.customFieldsForm.markAllAsTouched();
		const invalidControls = this.checkForm();
		if (invalidControls.length) {
			return;
		}

		this.isSubmittingForm = true;

		const payload = this._getPayloadUpdateStatusSolicitation(MovementStatusType.APPROVED);

		this._workforceplanService.postWorkforcePlanSolicitationUpdateStatus(payload.movementRequestId, payload).subscribe({
			next: (response) => {
				handleMovementRequestCommandOutcome({
					response,
					toast: this.toasterAbstract,
					onSuccess: () => {
						this.toasterAbstract.showSuccess("Solicitação de movimentação aprovada com sucesso.");
						this.isSubmittingForm = false;
						this.onSuccess.emit({ shouldRefetch: true });
					},
					onBlocked: () => {
						this.isSubmittingForm = false;
					},
				});
			},
			error: (error) => {
				handleMovementRequestCommandOutcome({
					error,
					toast: this.toasterAbstract,
					onSuccess: () => {},
					onBlocked: () => {
						this.isSubmittingForm = false;
					},
					blockedFallbackMessage: 'Não foi possível aprovar a solicitação. Verifique a causa e tente novamente.',
				});
			},
		});
	}

	public onEmplooyeeChanged(employee: NewRecruitmentEmployee) {
		if (employee) {
			this.form.patchValue({
				employee: employee,
				jobTitleId: employee.jobTitleId,
				timeShiftId: employee.timeshiftId,
				deadline: employee.resignationDate.substring(0, 10)
			});

			this.data.employee.registration = employee.registration;
		}
	}

	public onTrainingCenterCostChanged(data: OptionModel, originFieldName: string): void {
		const field = this.form.get(originFieldName);

		field.setValidators(Validators.required);

		if (data) {
			field.setValue(data.value);
			this.listJobTitleGroupsFromWorkforcePlan(data.value, this.data.employee.companyId);
		} else {
			field.setValue(null);
			this.lists.jobTitleGroupOptions = [];
		}
	}

	public ondisciplinaryMeasureChange(data: OptionModel) {
		this.amountDaysField.setValue(0);
		if (this.isSuspension) {
			this.amountDaysField.setValidators([Validators.required, Validators.min(1)]);
		} else {
			this.amountDaysField.clearValidators();
		}

		this.applyHiddenStandardFields();
	}

	public async onActiveEmployeeChanged(employee: NewRecruitmentEmployee) {
		this.data.employee.id = employee.id;
		this.data.employee.jobTitleId = employee.jobTitleId;
		this.data.employee.jobTitleName = employee.jobTitleName;
		await this._loadEmployeeTrainingData();

		this.lists.centerCostsOptions = [{ label: this.data.employee.costCenterName, value: this.data.employee.centerCostId }];
		this.lists.jobTitleGroupOptions = [{ label: this.data.employee.jobTitleGroupName, value: this.data.employee.jobTitleGroupId }];

		this._loadJobTitlesByJobTitleGroup(this.data.employee.jobTitleGroupId);

		this.form.patchValue({
			costCenterId: this.data.employee.centerCostId,
			jobTitleGroupId: this.data.employee.jobTitleGroupId,
			jobTitleId: this.data.employee.jobTitleId,
			tradeUnionId: this.data.employee.tradeUnionId
		});

		this.form.get("jobTitleId")?.updateValueAndValidity();
		if (this.warnIfSameAptitudeTrainingJobTitle()) {
			this.form.get("jobTitleId")?.setValue(null);
		}
	}

	public async onTrainedEmployeeChanged(employee: NewRecruitmentEmployee) {
		this.data.employee.id = employee.id;
		await this._loadEmployeeReplacementData();

		this.lists.currentCenterCostsOptions = [{ label: this.data.employee.costCenterName, value: this.data.employee.centerCostId }];
		this.lists.currentJobTitleOptions = [{ label: this.data.employee.jobTitleName, value: this.data.employee.jobTitleId }];

		this.lists.centerCostsOptions = [{ label: employee.costCenterName, value: employee.costCenterId }];
		this.lists.jobTitleOptions = [{ label: employee.jobTitleName, value: employee.jobTitleId }];

		this.form.patchValue({
			currentJobTitleId: this.data.employee.jobTitleId,
			currentJobTitleName: this.data.employee.jobTitleName,
			currentCostCenterId: this.data.employee.centerCostId,
			newCostCenterId: employee.costCenterId,
			newJobTitleId: employee.jobTitleId
		});
	}

	public getEmployeeJoTitleName() {
		if (this.data.mode === 'add') return this.data.employee?.jobTitleName;

		const { payloadData } = this.data?.solicitationDetails;
		return payloadData?.jobTitleName;
	}

	public getEmployeeJobTitleGroupName() {
		if (this.data.mode === 'add') return this.data?.employee?.jobTitleGroupName;

		const { payloadData } = this.data?.solicitationDetails;
		return payloadData?.jobTitleGroupName;
	}

	public getCurrentEmployeeJobTitleName() {
		return this.currentJobTitleName?.value
	}

	public onStartDateChange(ev: any) {
		this.minDate = moment(ev.target.value).add(1, "d").format("YYYY-MM-DD");
		this.form.get("endTrainingDate").setValidators([CustomValidators.minDate(this.minDate)]);
		this.form.get("endTrainingDate").updateValueAndValidity();
	}

	public onJobTitleGroupChanged(option: OptionModel) {
		if (!option) {
			this.lists.jobTitleOptions = [];
			this.form.get("jobTitleId").setValue(null)
			return;
		}

		this._loadJobTitlesByJobTitleGroup(option.value);
	}

	public onJobTitleChanged(option: OptionModel | null): void {
		const field = this.form.get("jobTitleId");
		if (!option) {
			field?.setValue(null);
			return;
		}

		if (this.data?.mode !== "add") {
			field?.setValue(option.value);
			return;
		}

		if (this.warnIfSameAptitudeTrainingJobTitle(option.value)) {
			field?.setValue(null);
			return;
		}

		field?.setValue(option.value);
	}

	async initializeForm() {
		const runId = ++this._initializeFormRunId;
		this.closeCancellationForm();

		const awaitsOpeningContext = this._isRestrictedCostCenterChangeAdd();
		if (awaitsOpeningContext) {
			this.drawerStatus = "loading";
		}

		if (this.data?.mode === 'details') {
			await this._getSolicitationDetails();
		}

		if (runId !== this._initializeFormRunId) {
			return;
		}

		this.drawerTitle = this.data?.solicitation?.movementTypeLabel;
		if (this.data?.mode === "add") {
			this.drawerTitle = this.data.hasSubType ? `Reposição por ${WorkforceplanMovementType.getByEnumerator(this.data.type)?.label}`
				: WorkforceplanMovementType.getByEnumerator(this.data.type)?.label;
		}

		if (awaitsOpeningContext) {
			await this._loadOpeningInstructionsBanner();
		} else {
			this._loadOpeningInstructionsBanner();
		}

		if (runId !== this._initializeFormRunId) {
			return;
		}

		if (this.openingInstructionsContextFailed) {
			this.toasterAbstract.showWarning(this.openingContextFailureMessage);
		}

		this._loadStepInstructionsBanner();

		switch (this.data.type) {
			case "EMPLOYEE_DETAILS": {
				this.drawerTitle = 'Detalhes do(a) colaborador(a)';
				this.employeeDetailsActiveTab = 'registration';
				this.canViewSensitiveEmployeeDetailsTabs = false;
				await this._loadEmployeeData();
				if (this._isStaleFormRun(runId)) {
					return;
				}
				await this._loadSensitiveEmployeeDetailsAccess();
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_TRAINING": {
				// Form is handled by dedicated component (InternalTrainingFormComponent)
				this.form = this._formBuilder.group({});
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}

			case "REQUEST_APTITUDE_TRAINING": {
				await this._loadFormRequestAptitudeTraining();
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			// case "JOBTITLE_CHANGE": {
			// 	await this._loadFormChangeJobTitle();

			// 	this.drawerStatus = "fetched";

			// 	break;
			// }
			case "COST_CENTER_AND_JOB_TITLE_CHANGE": {
				this.form = this._formBuilder.group({});
				if (!this._markDrawerFetched(runId)) {
					return;
				}
				break;
			}
			case "REQUEST_DISMISSAL": {
				this.form = this._formBuilder.group({});
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_HIRING_INCREASE": {
				if (this.data.mode === "add") {
					await this._loadFormRequestHiringExpansion();
				}

				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_HIRING_SUBSTITUTION": {
				await this._loadFormRequestHiringSubstitution();
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_HIRING_REPLACEMENT": {
				await this._loadFormRequestHiringReplacement();
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_PROMOTION": {
				this.form = this._formBuilder.group({});
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_WORK_FORCEPLAN": {
				this.form = this._formBuilder.group({});
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_FEEDBACK": {
				await this._loadFormRequestFeedback();
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
			case "REQUEST_DISCIPLINARY_MEASURE": {
				await this._loadFormRequestDisciplinary();
				if (!this._markDrawerFetched(runId)) {
					return;
				}

				break;
			}
		}

		if (this._isStaleFormRun(runId)) {
			return;
		}

		if (this.data?.mode === 'details') {
			await this._loadFormSolicitationDetails();
		}

		if (this._isStaleFormRun(runId)) {
			return;
		}

		await Promise.all([
			this._loadCustomFields(runId),
			this._loadHiddenStandardFields(runId),
		]);
	}

	public get isDrawerOpened() {
		return true;
	}

	private async _loadFormRequestTraining() {
		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			movementType: [WorkforceplanMovementType.TRAINNING.id],
			employeeId: [this.data.employee.id === guidEmpty ? null : this.data.employee.id],
			jobTitleId: [null, Validators.required],
			trainingTypeId: [null, Validators.required],
			trainingTypeName: [],
			costCenterId: [null, Validators.required],
			workScaleGroup: [this.data?.workScaleGroup ?? null, Validators.required],
			jobTitleGroupId: [null, Validators.required],
			workforcePlanId: [this.data.workforcePlanId],
			startTrainingDate: [],
			endTrainingDate: [],
			isApproved: [],
			newSalary: [],
			tradeUnionId: [],
			tradeUnionName: [],
			changeTypeCode: [],
			hasDangerousness: [false],
			unhealthinessType: []
		});

		if (this.data.hasSubType) {
			await this._loadActiveEmployees();
		} else {
			await this._loadEmployeeData();
		}

		this.lists.workScaleGroupOptions = (this.data.workScaleGroups || []).map((w) => ({
			label: `Turno ${w.workScaleGroup}`,
			value: w.workScaleGroup,
		} as OptionModel));

		this.loadTrainings(false);
		this._loadTradeUnionsOptions();
		this._loadEffectiveCostCentersByCompany();
	}

	private async _loadFormRequestAptitudeTraining() {
		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			movementType: [WorkforceplanMovementType.APTITUDE_TRAINNING.id],
			employeeId: [this.data.employee.id === guidEmpty ? null : this.data.employee.id],
			jobTitleId: [null, [Validators.required, this.sameAptitudeTrainingJobTitleValidator]],
			trainingTypeId: [null, Validators.required],
			trainingTypeName: [],
			costCenterId: [null, Validators.required],
			workScaleGroup: [this.data?.workScaleGroup],
			jobTitleGroupId: [null, Validators.required],
			workforcePlanId: [this.data.workforcePlanId],
			startTrainingDate: [],
			endTrainingDate: [],
			isApproved: [],
		});

		await this._loadEmployeeData();

		this.loadTrainings(true);
		this._loadEffectiveCostCentersByCompany();
	}

	// private async _loadFormChangeJobTitle() {
	// 	await this._loadEmployeeData();

	// 	this.form = this._formBuilder.group({
	// 		note: [null, Validators.required],
	// 		employeeId: [this.data.employee.id],
	// 		movementType: [WorkforceplanMovementType.JOB_TITLE_CHANGE.id],
	// 		newJobTitleId: [null, Validators.required],
	// 		workScaleGroup: [this.data?.workScaleGroup],
	// 		workforcePlanId: [this.data.workforcePlanId],
	// 		currentJobTitleId: [this.data.employee.jobTitleId],
	// 	});

	// 	this._loadJobTitleOfPlanWorkScaleGroups();
	// }

	private async _loadFormRequestHiringExpansion() {
		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			raiseType: [MovementRequestRaiseType.Expansion.value, Validators.required],
			amount: [null, Validators.required],
			jobTitleId: [null],
			timeShiftId: [null, Validators.required],
			movementType: [WorkforceplanMovementType.NEW_HIRING_INCREASE.id],
			workScaleGroup: [this.data.workScaleGroup],
			workforcePlanId: [this.data.workforcePlanId],
			jobTitleGroupId: [null, Validators.required],
		});

		this.lists.hiringTypeOptions = [
			{ label: MovementRequestRaiseType.Expansion.label, value: MovementRequestRaiseType.Expansion.value },
		];

		this._loadJobTitleGroupsByCompany(this.data.companyId);

		await this._loadTimeShiftsByCompany();
	}

	private _loadFormSolicitationDetailsHiringIncrease(): void {
		const { solicitation, solicitationDetails } = this.data;
		const payload = solicitationDetails?.payloadData;

		this.form = this._formBuilder.group({
			note: [solicitationDetails?.note],
			raiseType: [payload?.raiseType ?? MovementRequestRaiseType.Expansion.value],
			amount: [payload?.amount],
			jobTitleId: [payload?.jobTitleId],
			timeShiftId: [payload?.timeShiftId ?? solicitationDetails?.employeeTimeShiftId],
			movementType: [solicitation?.movementTypeData?.id],
			workScaleGroup: [solicitation?.workScaleGroup],
			workforcePlanId: [this.data.workforcePlanId],
			jobTitleGroupId: [payload?.jobTitleGroupId],
		});

		this.justification = solicitationDetails?.stepNote ?? "";

		this.lists.hiringTypeOptions = [
			{ label: MovementRequestRaiseType.Expansion.label, value: MovementRequestRaiseType.Expansion.value },
		];
		this.lists.jobTitleGroupOptions = [
			{ label: payload?.jobTitleGroupName, value: payload?.jobTitleGroupId },
		];
		this.lists.jobTitleOptions = [
			{ label: payload?.jobTitleName, value: payload?.jobTitleId },
		];
		this.lists.timeShiftsOptions = [
			{ title: payload?.timeShiftName, id: payload?.timeShiftId } as TimeShiftModel,
		];

		if (!this.data?.solicitationDetails?.permission?.canUpdate) {
			this.form.disable();
		}
	}

	private async _loadFormRequestHiringSubstitution() {
		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			deadline: [null],
			employee: [],
			raiseType: [MovementRequestRaiseType.Substitution.value, Validators.required],
			employeeId: [null, Validators.required],
			jobTitleId: ["00000000-0000-0000-0000-000000000000"],
			timeShiftId: ["00000000-0000-0000-0000-000000000000"],
			movementType: [WorkforceplanMovementType.NEW_HIRING_SUBSTITUTION.id],
			workScaleGroup: [this.data.workScaleGroup],
			workforcePlanId: [this.data.workforcePlanId]
		});

		this._loadJobTitleOfPlanWorkScaleGroups();

		await this._loadTimeShiftsByCompany();

		await this._loadEmployeesInProcessResignation();
	}

	private isHiringReplacementHeadcountIncrease(source?: {
		increaseVacancyId?: string | null;
		isHeadcountIncreasePending?: boolean;
	} | null): boolean {
		return !!source?.increaseVacancyId || !!source?.isHeadcountIncreasePending;
	}

	private resolveHiringReplacementRaiseType(params: {
		raiseType?: string | number | null;
		isHeadcountIncrease: boolean;
	}): MovementRequestRaiseType {
		const fallback = params.isHeadcountIncrease
			? MovementRequestRaiseType.Expansion
			: MovementRequestRaiseType.Replacement;

		if (params.raiseType == null || params.raiseType === '') {
			return fallback;
		}

		const resolved = typeof params.raiseType === 'number'
			? MovementRequestRaiseType.getById(params.raiseType)
			: MovementRequestRaiseType.getBy(String(params.raiseType));

		return (resolved as MovementRequestRaiseType) ?? fallback;
	}

	private async _loadFormRequestHiringReplacement() {
		const raiseTypeEnum = this.resolveHiringReplacementRaiseType({
			isHeadcountIncrease: this.isHiringReplacementHeadcountIncrease(this.data?.employee),
		});

		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			raiseType: [raiseTypeEnum.value, Validators.required],
			jobTitleId: [this.data?.employee?.jobTitleId, Validators.required],
			timeShiftId: [null, Validators.required],
			movementType: [WorkforceplanMovementType.NEW_HIRING_REPLACEMENT.id],
			workScaleGroup: [this.data?.workScaleGroup],
			workforcePlanId: [this.data?.workforcePlanId],
			jobTitleGroupId: [this.data?.employee?.jobTitleGroupId, Validators.required],
			increaseVacancyId: [this.data?.employee?.increaseVacancyId || null],
		});

		this.lists.hiringTypeOptions = [
			{
				label: raiseTypeEnum.label,
				value: raiseTypeEnum.value,
			},
		];

		if (this.data?.employee?.jobTitleGroupId) {
			this.lists.jobTitleGroupOptions = [{
				label: this.data.employee.jobTitleGroupName || '',
				value: this.data.employee.jobTitleGroupId
			} as OptionModel];
		}

		if (this.data?.employee?.jobTitleId && this.data?.employee?.jobTitleId !== guidEmpty) {
			this.lists.jobTitleOptions = [{
				label: this.data.employee.jobTitleName || '',
				value: this.data.employee.jobTitleId
			} as OptionModel];

			this.form.get('jobTitleId').disable();
		} else if (this.data?.employee?.jobTitleGroupId) {
			this._loadJobTitlesByJobTitleGroup(this.data.employee.jobTitleGroupId);
		}

		await this._loadTimeShiftsByCompany();
	}

	private async _loadFormRequestFeedback() {
		await this._loadEmployeeData();

		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			movementType: [WorkforceplanMovementType.DISCIPLINARY_MEASURE.id],
			workScaleGroup: [this.data?.workScaleGroup],
			employeeId: [this.data?.employee.id],
			workforcePlanId: [this.data?.workforcePlanId],
			occurenceType: [null, Validators.required],
			occurrenceJustification: [null],
			amountDays: [0],
			occurenceDate: [null, [Validators.required, CustomValidators.maxDate(moment().endOf("day").format("yyyy-MM-DD"))]]
		});
	}

	private async _loadFormRequestDisciplinary() {
		await this._loadEmployeeData();

		this.form = this._formBuilder.group({
			note: [null, Validators.required],
			movementType: [WorkforceplanMovementType.DISCIPLINARY_MEASURE.id],
			workScaleGroup: [this.data?.workScaleGroup],
			employeeId: [this.data?.employee.id],
			workforcePlanId: [this.data?.workforcePlanId],
			occurenceType: [null, Validators.required],
			occurrenceJustification: [null],
			amountDays: [0],
			occurenceDate: [null, [Validators.required, CustomValidators.maxDate(moment().endOf("day").format("yyyy-MM-DD"))]]
		});
	}

	private async _loadFormSolicitationDetails() {
		const { solicitation, solicitationDetails } = this.data;

		if (this.data.type === "COST_CENTER_AND_JOB_TITLE_CHANGE") {
			this.justification = solicitationDetails?.stepNote ?? "";
			return;
		}
		if (this.data.type === "REQUEST_TRAINING") {
			// Details form is handled by dedicated component (InternalTrainingFormComponent)
			this.justification = solicitationDetails?.stepNote ?? "";
			return;
		}
		if (this.data.type === "REQUEST_WORK_FORCEPLAN") {
			this.justification = solicitationDetails?.stepNote ?? "";
			return;
		}
		if (this.data.type === "REQUEST_HIRING_INCREASE") {
			this._loadFormSolicitationDetailsHiringIncrease();
			return;
		}
		if (this.data.type === "REQUEST_DISMISSAL") {
			// Details form is handled by dedicated component (DismissalFormComponent)
			this.justification = solicitationDetails?.stepNote ?? "";
			return;
		}

		this.form = this._formBuilder.group({
			note: [solicitationDetails?.note],
			movementType: [solicitation?.movementTypeData?.id],
			workforcePlanId: [this.data.workforcePlanId],
			employeeId: [solicitation?.employeeId],
			jobTitleId: [solicitationDetails?.payloadData?.jobTitleId],
			workScaleGroup: [solicitation?.workScaleGroup],
			trainingTypeId: [solicitationDetails?.payloadData?.trainingTypeId],
			trainingTypeName: [solicitationDetails?.payloadData?.trainingTypeName],
			costCenterId: [solicitationDetails?.payloadData?.costCenterId],
			effectiveDate: [solicitation?.effectiveDate?.substring(0, 10)],
			expectedDate: [solicitationDetails?.payloadData?.expectedDate?.substring(0, 10)],
			jobTitleGroupId: [solicitationDetails?.payloadData?.jobTitleGroupId],
			startTrainingDate: [solicitationDetails?.payloadData?.startTrainingDate?.substring(0, 10)],
			endTrainingDate: [solicitationDetails?.payloadData?.endTrainingDate?.substring(0, 10)],
			executionDate: [solicitationDetails?.payloadData?.executionDate?.substring(0, 10)],
			isApproved: [solicitationDetails?.payloadData?.isApproved],
			newSalary: [solicitationDetails?.payloadData?.newSalary],
			tradeUnionId: [solicitationDetails?.payloadData?.tradeUnionId],
			changeTypeCode: [solicitationDetails?.payloadData?.changeTypeCode],
			hasDangerousness: [solicitationDetails?.payloadData?.hasDangerousness],
			unhealthinessType: [solicitationDetails?.payloadData?.unhealthinessType],
			newJobTitleGroupId: [solicitationDetails?.payloadData?.newJobTitleGroupId],
			newJobTitleGroupName: [solicitationDetails?.payloadData?.newJobTitleGroupName],
			newJobTitleId: [solicitationDetails?.payloadData?.newJobTitleId],
			currentJobTitleId: [solicitationDetails?.payloadData?.currentJobTitleId],
			newCostCenterId: [solicitationDetails?.payloadData?.newCostCenterId],
			currentCostCenterId: [solicitationDetails?.payloadData?.currentCostCenterId],
			resignationReason: [solicitationDetails?.payloadData?.resignationReason],
			wasEmployeeInitiative: [solicitationDetails?.payloadData?.wasEmployeeInitiative],
			vacancyReplacement: [solicitationDetails?.payloadData?.vacancyReplacement],
			raiseType: [solicitationDetails?.payloadData?.raiseType],
			timeShiftId: [solicitationDetails?.employeeTimeShiftId],
			deadline: [solicitationDetails?.payloadData?.deadline],
			amount: [solicitationDetails?.payloadData?.amount],
			employee: [],
			amountDays: [solicitationDetails?.payloadData?.amountDays],
			occurenceDate: [solicitationDetails?.payloadData?.occurenceDate?.substring(0, 10)],
			dismissalType: [],
			occurenceType: [],
			occurrenceJustification: []
		});
		this.justification = solicitationDetails.stepNote;

		if (!this.data?.solicitationDetails?.permission?.canUpdate) {
			this.form.disable();
		}

		if (this.data.type === 'REQUEST_HIRING_SUBSTITUTION') {
			const employee = this.lists.employeesResignationsOptions.find(item => item.id === solicitation.employeeId);

			this.onEmplooyeeChanged(employee)
		}

		if (this.data.type === 'REQUEST_DISCIPLINARY_MEASURE') {
			const occurenceType = solicitationDetails?.payloadData?.occurenceType
			if (occurenceType) {
				this.form.patchValue({
					occurenceType: occurenceType
				});
			}

			const occurrenceJustification = solicitationDetails?.payloadData?.occurrenceJustification;
			if (occurrenceJustification) {
				this.form.patchValue({
					occurrenceJustification: occurrenceJustification
				});
			}

			if (this.isSuspension) {
				this.amountDaysField.setValidators([Validators.required, Validators.min(1)]);
			}

			if (this.canSelectOccurenceCodeAndUpdateJustification) {
				this.form.get('note')?.enable();
				this.occurrenceJustificationField?.enable();
				this.occurrenceJustificationField?.setValue(null);
				this.occurrenceJustificationField?.setValidators([Validators.required]);
			}
		}

		if (this.data.type === 'REQUEST_FEEDBACK') {
			const occurenceType = solicitationDetails?.payloadData?.occurenceType
			if (occurenceType) {
				this.form.patchValue({
					occurenceType: occurenceType
				});
			}

			const occurrenceJustification = solicitationDetails?.payloadData?.occurrenceJustification;
			if (occurrenceJustification) {
				this.form.patchValue({
					occurrenceJustification: occurrenceJustification
				});
			}

			if (this.isSuspension) {
				this.amountDaysField.setValidators([Validators.required, Validators.min(1)]);
			}

			if (this.canSelectOccurenceCodeAndUpdateJustification) {
				this.form.get('note')?.enable();
				this.occurrenceJustificationField?.enable();
				this.occurrenceJustificationField?.setValue(null);
				this.occurrenceJustificationField?.setValidators([Validators.required]);
			}
		}

		if (this.data.type === 'REQUEST_HIRING_REPLACEMENT') {
			const payload = solicitationDetails?.payloadData;
			const raiseTypeEnum = this.resolveHiringReplacementRaiseType({
				raiseType: payload?.raiseType,
				isHeadcountIncrease: this.isHiringReplacementHeadcountIncrease(payload),
			});

			this.form.patchValue({
				timeShiftId: payload?.timeShiftId,
				jobTitleGroupId: payload?.jobTitleGroupId,
				jobTitleId: payload?.jobTitleId,
				raiseType: raiseTypeEnum.value,
			});

			this.lists.hiringTypeOptions = [{
				label: raiseTypeEnum.label,
				value: raiseTypeEnum.value,
			}];
			this.lists.jobTitleGroupOptions = [{ label: payload?.jobTitleGroupName, value: payload?.jobTitleGroupId }]
			this.lists.jobTitleOptions = [{ label: payload?.jobTitleName, value: payload?.jobTitleId }]
			this.lists.timeShiftsOptions = [{ title: payload?.timeShiftName, id: payload?.timeShiftId } as TimeShiftModel]
		}

		if (this.data.type === 'REQUEST_APTITUDE_TRAINING' && this.data.mode === 'details') {
			this.lists.centerCostsOptions = [{ label: solicitationDetails?.payloadData?.costCenterName, value: solicitationDetails?.payloadData?.costCenterId }];
			this.lists.jobTitleGroupOptions = [{ label: solicitationDetails?.payloadData?.jobTitleGroupName, value: solicitationDetails?.payloadData?.jobTitleGroupId }]
			this.lists.jobTitleOptions = [{ label: solicitationDetails?.payloadData?.jobTitleName, value: solicitationDetails?.payloadData?.jobTitleId }];

			if (this.canEditFieldToStartTraining) {
				this.startTrainingDate?.enable();
				this.startTrainingDate?.setValidators([Validators.required, CustomValidators.minDate(this.minDate)]);
			}

			if (this.canEditTrainingCompletion) {
				const startTrainingData = moment(solicitationDetails?.payloadData?.startTrainingDate).add(1, "d").format("YYYY-MM-DD");
				this.endTrainingDate?.enable();
				this.endTrainingDate?.setValidators([Validators.required, CustomValidators.minDate(startTrainingData)]);

				this.form.get('isApproved')?.enable();
				this.form.get('isApproved')?.setValidators([Validators.required]);
				this.form.get('isApproved')?.updateValueAndValidity();
			} else if (this.canEditOptionApprovalTraining) {
				this.endTrainingDate?.disable({ emitEvent: false });
				this.form.get('isApproved')?.disable({ emitEvent: false });
			}
		}

	}

	private async _loadSensitiveEmployeeDetailsAccess() {
		const employeeId = this.data?.employee?.id;
		if (!employeeId || employeeId === guidEmpty) {
			this.canViewSensitiveEmployeeDetailsTabs = false;
			return;
		}

		try {
			const access = await this._hierarchyLeaderService.getSensitiveDataAccess(employeeId).toPromise();
			this.canViewSensitiveEmployeeDetailsTabs = !!access?.canViewSensitiveData;
		} catch (error) {
			console.error(error);
			this.canViewSensitiveEmployeeDetailsTabs = false;
		}

		if (!this.canViewSensitiveEmployeeDetailsTabs && this.employeeDetailsActiveTab !== 'registration') {
			this.employeeDetailsActiveTab = 'registration';
		}
	}

	private async _loadEmployeeData() {
		try {
			if (this.data.employee.id === guidEmpty) return;

			this.drawerStatus = "loading";

			const employee = Object.assign({}, this.data.employee);

			const { data } = await this._employeeService.get(employee.id, true).toPromise();

			employee.companyId = data.companyId;
			employee.admissionDate = data.admissionDate;
			employee.cellPhoneNumber = this._formatPhoneSafe(data.cellPhoneNumber);
			employee.profileImagePath = data.profileImagePath;
			employee.timeShiftId = data.timeShiftId;
			employee.centerCostId = data.costCenterId;
			employee.costCenterName = data.costCenterName;
			employee.jobTitleId = data.jobTitleId;
			employee.jobTitleName = data.jobTitleName;
			employee.tradeUnionId = data.tradeUnionId;

			this.data.employee = {
				...data,
				...employee,
				emergencyContact: this._formatPhoneSafe(data.emergencyContact),
				emergencyName: this._normalizeDisplayValue(data.emergencyName, ''),
				emergencyKinship: this._normalizeDisplayValue(data.emergencyKinship, ''),
				emergencyEmail: this._normalizeDisplayValue(data.emergencyEmail, ''),
			} as any;

			if (employee.status && this.data.type === 'EMPLOYEE_DETAILS') {
				this.data.employee.status = WorkforceplanEmployeeStatusType.getBy(employee.status).label;
			}

			this.drawerStatus = "fetched";
		} catch (error) {
			console.error(error);

			this.drawerStatus = "error";
		}
	}

	private async _loadEmployeeTrainingData() {
		try {
			this.drawerStatus = "loading";

			const employee = Object.assign({}, this.data.employee);

			const { data } = await this._employeeService.get(employee.id, true).toPromise();

			employee.companyId = data.companyId;
			employee.profileImagePath = data.profileImagePath;
			employee.timeShiftId = data.timeShiftId;
			employee.centerCostId = data.costCenterId;
			employee.costCenterName = data.costCenterName;
			employee.tradeUnionId = data.tradeUnionId;
			employee.jobTitleId = data.jobTitleId;
			employee.jobTitleName = data.jobTitleName;
			employee.cellPhoneNumber = this._formatPhoneSafe(data.cellPhoneNumber);

			this.data.employee = {
				...employee
			} as any;

			if (employee.status && this.data.type === 'EMPLOYEE_DETAILS') {
				this.data.employee.status = WorkforceplanEmployeeStatusType.getBy(employee.status).label;
			}

			this.drawerStatus = "fetched";
		} catch (error) {
			console.error(error);

			this.drawerStatus = "error";
		}
	}

	private async _loadEmployeeReplacementData() {
		try {
			if (this.data.employee.id === guidEmpty) return;

			this.drawerStatus = "loading";

			const employee = Object.assign({}, this.data.employee);

			const { data } = await this._employeeService.get(employee.id, true).toPromise();

			employee.companyId = data.companyId;
			employee.admissionDate = data.admissionDate;
			employee.cellPhoneNumber = this._formatPhoneSafe(data.cellPhoneNumber);
			employee.profileImagePath = data.profileImagePath;
			employee.timeShiftId = data.timeShiftId;
			employee.centerCostId = data.costCenterId;
			employee.costCenterName = data.costCenterName;
			employee.jobTitleId = data.jobTitleId;
			employee.jobTitleName = data.jobTitleName;
			employee.tradeUnionId = data.tradeUnionId;

			this.data.employee = {
				...employee,
				...data,
				emergencyContact: this._formatPhoneSafe(data.emergencyContact),
				emergencyName: this._normalizeDisplayValue(data.emergencyName, ''),
				emergencyKinship: this._normalizeDisplayValue(data.emergencyKinship, ''),
				emergencyEmail: this._normalizeDisplayValue(data.emergencyEmail, ''),
			} as any;

			if (employee.status && this.data.type === 'EMPLOYEE_DETAILS') {
				this.data.employee.status = WorkforceplanEmployeeStatusType.getBy(employee.status).label;
			}

			this.drawerStatus = "fetched";
		} catch (error) {
			console.error(error);

			this.drawerStatus = "error";
		}
	}

	private _loadJobTitlesByJobTitleGroup(jobTitleGroupId: string) {
		this._jobTitleService.getJobTitlesByTitleAndGroup(this.data.companyId, jobTitleGroupId).subscribe(data => {
			this.lists.jobTitleOptions = data.map(item => ({ label: `${item.code} - ${item.title}`, value: item.id } as OptionModel))
		});
	}

	private _loadJobTitleOfPlanWorkScaleGroups() {
		const jobTitles = new Map();
		const jobTitleGroups = new Map();

		this.data.workScaleGroups?.forEach((item) => {
			item.amounts.forEach(({ jobTitleId, jobTitleName, jobTitleGroupId, jobTitleGroupName }) => {
				if (jobTitleGroupId) {
					jobTitleGroups.set(jobTitleGroupId, { jobTitleGroupId, jobTitleGroupName });
				}
				if (jobTitleId) {
					jobTitles.set(jobTitleId, { jobTitleId, jobTitleName });
				}
			});
		});

		this.lists.jobTitleOptions = [...jobTitles.values()].map(
			(item) => ({ label: item.jobTitleName, value: item.jobTitleId } as OptionModel)
		);

		this.lists.jobTitleGroupOptions = [...jobTitleGroups.values()].map(
			(item) => ({ label: item.jobTitleGroupName, value: item.jobTitleGroupId } as OptionModel)
		);
	}

	private listJobTitleGroupsFromWorkforcePlan(costCenterId: string, companyId: string) {
		this._workforceplanService.listJobTitleGroupsFromWorkforcePlan(companyId, costCenterId).subscribe((data) => {
			this.lists.jobTitleGroupOptions = data.data;
		}, (error) => {
			console.error('Erro ao carregar grupos de cargo:', error);
			this.lists.jobTitleGroupOptions = [];
		});
	}

	private _loadJobTitleGroupsByCompany(companyId: string) {
		this._jobTitleGroupService.getJobTitleGroupsByCompany(companyId).subscribe(res => {
			this.lists.jobTitleGroupOptions = res.map(
				item =>
					({
						label: item.name,
						value: item.id,
					}) as OptionModel
			);
		});
	}

	private _listJobTitlesFromEffectiveWorkforcePlan(costCenterId: string, companyId: string) {
		this._jobTitleService.listFromEffectiveWorkforcePlan(companyId, costCenterId).subscribe((data) => {
			this.lists.jobTitles = data.body.map(item => JobTitleModel.create(item));
			this.lists.jobTitleOptions = data.body.map(item => ({ label: `${item.code} - ${item.title}`, value: item.id } as OptionModel));
		}, (error) => {
			console.error('Erro ao carregar funções:', error);
			this.lists.jobTitles = [];
			this.lists.jobTitleOptions = [];
		});
	}

	private loadTrainings(isAptitude?: boolean): void {
		this._trainingService.listTrainings().subscribe(
			(res) => {
				const trainings = res.data.filter(x => isAptitude !== null ? x.isAptitude === isAptitude : this.data.hasSubType ? x.validateHeadcountPlanning : true);
				this.trainingOptions = trainings.map(training => training.toOption());

				if (trainings.length === 1 && !this.form.get("trainingTypeId").value)
					this.form.get("trainingTypeId").setValue(trainings[0].id);
			},
			(error) => {
				console.error(error);

				this.toasterAbstract.showError("Ocorreu um erro inesperado");
			}
		);
	}

	private loadMovementTypes(): void {
		this._movementTypeService.listMovementTypes().subscribe(
			(res) => {
				this.lists.movementTypeOptions = res.data.map((item) => ({ label: `${item.foreignId} - ${item.name}`, value: item.foreignId } as OptionModel));
			},
			(error) => {
				console.error(error);
				this.lists.movementTypeOptions = [];

				this.toasterAbstract.showError("Ocorreu um erro inesperado");
			}
		);
	}

	private async _loadTimeShiftsByCompany() {
		try {
			const params = {
				companyId: this.data.companyId,
				workScaleGroup: this.data.workScaleGroup,
			};

			const data = await this._timeShiftService.loadTimeShiftsByParams(params).toPromise();

			this.lists.timeShiftsOptions = data
		} catch (error) {
			console.log(error);

			this.lists.timeShiftsOptions = [];
		}
	}

	private async _loadEmployeesInProcessResignation() {
		try {

			const data = await this._service.getListEmployeesInResignation(this.data.workforcePlanId).toPromise();

			this.lists.employeesResignationsOptions = data;
		} catch (error) {
			console.error(error);

			this.lists.employeesResignationsOptions = [];
		}
	}

	private async _loadActiveEmployees() {
		try {
			const data = await this._service.getListActiveEmployees(this.data.workforcePlanId).toPromise();
			this.lists.activeEmployees = data;
		} catch (error) {
			console.error(error);
			this.lists.employeesInWorkScaleGroup = [];
		}
	}

	private _loadEffectiveCostCentersByCompany() {
		this._workforceplanService.listEffectiveCostCentersByCompany(this.data.companyId)
			.subscribe((response) => {
				this.lists.centerCostsOptions = response.data;
			})
	}

	private _loadTradeUnionsOptions() {
		const params = {
			select: ["id", "code", "name"],
			filter: Filter.equalToGuid("companyId", this.data.companyId),
		} as QueryParams;
		this._domainService
			.getTradeUnions(params)
			.subscribe((response) => {
				this.lists.tradeUnionsOptions = response.data.map(i => i.toOption());
			});
	}

	private _getJobTitleGroupOption(jobTitleGroupId: string) {
		const { label } = this.lists.jobTitleGroupOptions.find(item => item.value === jobTitleGroupId);

		return label
	}

	private _getJobTitleOption(jobTitleId: string) {
		const { label } = this.lists.jobTitleOptions.find(item => item.value === jobTitleId);

		return label.split(' - ')[1] || label;
	}

	private _getTimeshiftTitleOption(timeshiftId: string) {
		const { title } = this.lists.timeShiftsOptions.find(item => item.id === timeshiftId);

		return title
	}

	private _getCostCenterTitleOption(costCenterId: string) {
		const { label } = this.lists.centerCostsOptions.find(item => item.value === costCenterId);

		return label.split(' - ')[1] || label;
	}

	private _getTradeUnionTitleOption(tradeUnionId: string) {
		if (!tradeUnionId) return null;

		const { label } = this.lists.tradeUnionsOptions.find(item => item.value === tradeUnionId);

		return label
	}

	private _getTrainingNameOption(trainingTypeId: string) {
		if (!trainingTypeId) return null;

		const { label } = this.trainingOptions.find(item => item.value === trainingTypeId);

		return label
	}

	private _getPayload() {
		switch (this.data.type) {
			case "REQUEST_TRAINING": {
				const {
					note,
					employeeId,
					jobTitleId,
					movementType,
					trainingTypeId,
					effectiveDate,
					workforcePlanId,
					costCenterId,
					jobTitleGroupId,
					startTrainingDate,
					endTrainingDate,
					workScaleGroup,
					isApproved,
					changeTypeCode,
					hasDangerousness,
					unhealthinessType,
					newSalary,
					tradeUnionId
				} = this.form.value as RequestTrainingValues

				const jobTitleName = this._getJobTitleOption(jobTitleId);
				const jobTitleGroupName = this._getJobTitleGroupOption(jobTitleGroupId);
				const costCenterName = this._getCostCenterTitleOption(costCenterId);
				const tradeUnionName = this._getTradeUnionTitleOption(tradeUnionId);
				const trainingTypeName = this._getTrainingNameOption(trainingTypeId);

				return {
					note,
					employeeId,
					movementType,
					effectiveDate,
					workScaleGroup,
					workforcePlanId,
					payload: JSON.stringify({
						jobTitleId,
						jobTitleName,
						jobTitleGroupId,
						jobTitleGroupName,
						costCenterId,
						costCenterName,
						trainingTypeId,
						trainingTypeName,
						startTrainingDate,
						endTrainingDate,
						isApproved,
						changeTypeCode,
						hasDangerousness,
						unhealthinessType,
						newSalary,
						tradeUnionId,
						tradeUnionName
					}),
				} as RequestTrainingPayload;
			}

			case "REQUEST_APTITUDE_TRAINING": {
				const {
					note,
					employeeId,
					jobTitleId,
					movementType,
					trainingTypeId,
					effectiveDate,
					workforcePlanId,
					costCenterId,
					jobTitleGroupId,
					startTrainingDate,
					endTrainingDate,
					workScaleGroup,
					isApproved,
				} = this.form.getRawValue() as RequestAptitudeTrainingValues

				const jobTitleName = this._getJobTitleOption(jobTitleId);
				const jobTitleGroupName = this._getJobTitleGroupOption(jobTitleGroupId);
				const costCenterName = this._getCostCenterTitleOption(costCenterId);
				const trainingTypeName = this._getTrainingNameOption(trainingTypeId);

				return {
					note,
					employeeId,
					movementType,
					effectiveDate,
					workScaleGroup,
					workforcePlanId,
					payload: JSON.stringify({
						jobTitleId,
						jobTitleName,
						jobTitleGroupId,
						jobTitleGroupName,
						costCenterId,
						costCenterName,
						trainingTypeId,
						trainingTypeName,
						startTrainingDate,
						endTrainingDate,
						isApproved
					}),
				} as RequestAptitudeTrainingPayload;
			}
			// case "JOBTITLE_CHANGE": {
			// 	const {
			// 		note,
			// 		employeeId,
			// 		movementType,
			// 		newJobTitleId,
			// 		workScaleGroup,
			// 		workforcePlanId,
			// 		currentJobTitleId,
			// 	} = this.form.value as FormJobTitleChangeValues;

			// 	const newJobTitleName = this._getJobTitleOption(newJobTitleId);
			// 	const currentJobTitleName = this.data?.employee?.jobTitleName;

			// 	return {
			// 		note,
			// 		employeeId,
			// 		movementType,
			// 		workScaleGroup,
			// 		workforcePlanId,
			// 		payload: JSON.stringify({
			// 			newJobTitleId,
			// 			newJobTitleName,
			// 			currentJobTitleId,
			// 			currentJobTitleName,
			// 		}),
			// 	} as FormJobTitleChangePayload;
			// }
			case "REQUEST_HIRING_INCREASE": {
				const {
					note,
					raiseType,
					jobTitleId,
					timeShiftId,
					movementType,
					workScaleGroup,
					workforcePlanId,
					jobTitleGroupId,
					amount
				} = this.form.value as FormRequestHiringIncreaseValues;

				const jobTitleGroupName = this._getJobTitleGroupOption(jobTitleGroupId);
				const timeShiftName = this._getTimeshiftTitleOption(timeShiftId);

				const jobTitleInfos = !!jobTitleId ? { jobTitleId, jobTitleName: this._getJobTitleOption(jobTitleId) } : {};

				return {
					note,
					movementType,
					workScaleGroup,
					workforcePlanId,
					payload: JSON.stringify({
						raiseType,
						timeShiftId,
						timeShiftName,
						jobTitleGroupId,
						jobTitleGroupName,
						amount,
						...jobTitleInfos
					}),
				} as FormRequestHiringIncreasePayload;
			}
			case "REQUEST_DISMISSAL": {
                const {
                    note,
                    employeeId,
                    movementType,
                    effectiveDate,
                    workScaleGroup,
                    workforcePlanId,
                    resignationReason,
                    dismissalType,
                    wasEmployeeInitiative,
                    vacancyReplacement,
                    expectedDate,
                } = this.form.getRawValue() as FormRequestDismissalValues;

                return {
                    note,
                    employeeId,
                    movementType,
                    effectiveDate,
                    workScaleGroup,
                    workforcePlanId,
                    payload: JSON.stringify({
                        resignationReason,
                        wasEmployeeInitiative,
                        expectedDate,
                        dismissalType: Number(dismissalType),
                        vacancyReplacement,
                    }),
                } as FormRequestDismissalPayload;
            }
			case "REQUEST_HIRING_SUBSTITUTION": {
				const {
					note,
					deadline,
					raiseType,
					employeeId,
					jobTitleId,
					timeShiftId,
					movementType,
					workScaleGroup,
					workforcePlanId
				} = this.form.value as FormRequestHiringSubstitutionValues

				const jobTitleName = this.employeeSelected?.jobTitleName;
				const timeShiftName = this.employeeSelected?.timeshiftTitle

				return {
					note,
					employeeId,
					movementType,
					workScaleGroup,
					workforcePlanId,
					payload: JSON.stringify({
						deadline,
						raiseType,
						jobTitleId,
						timeShiftId,
						jobTitleName,
						timeShiftName
					}),
				} as FormRequestHiringSubstitutionPayload;
			}
			case "REQUEST_HIRING_REPLACEMENT": {
				const {
					note,
					raiseType,
					jobTitleId,
					timeShiftId,
					movementType,
					workScaleGroup,
					workforcePlanId,
					jobTitleGroupId,
					increaseVacancyId,
				} = this.form.getRawValue() as FormRequestHiringReplacementValues & { increaseVacancyId?: string };

				const timeShiftName = this._getTimeshiftTitleOption(timeShiftId);
				const jobTitleName = this._getJobTitleOption(jobTitleId);
				const jobTitleGroupName = this._getJobTitleGroupOption(jobTitleGroupId);

				return {
					note,
					movementType,
					workScaleGroup,
					workforcePlanId,
					payload: JSON.stringify({
						raiseType,
						timeShiftId,
						timeShiftName,
						jobTitleId,
						jobTitleName,
						jobTitleGroupId,
						jobTitleGroupName,
						increaseVacancyId: increaseVacancyId || null,
					}),
				} as FormRequestHiringReplacementPayload;
			}
			case "REQUEST_DISCIPLINARY_MEASURE": {
				const {
					note,
					movementType,
					workforcePlanId,
					workScaleGroup,
					employeeId,
					occurenceType,
					occurrenceJustification,
					amountDays,
					occurenceDate
				} = this.form.getRawValue() as FormRequestDisciplinaryMeasure;

				return {
					note,
					movementType,
					workforcePlanId,
					employeeId,
					workScaleGroup,

					payload: JSON.stringify({
						occurrenceJustification: occurrenceJustification,
						occurenceType: occurenceType,
						amountDays,
						occurenceDate
					}),
				} as FormRequestDisciplinaryMeasurePayload;
			}

			case "REQUEST_FEEDBACK": {
				const {
					note,
					movementType,
					workforcePlanId,
					workScaleGroup,
					employeeId,
					occurenceType,
					occurrenceJustification,
					amountDays,
					occurenceDate
				} = this.form.value as FormFeedback;

				return {
					note,
					movementType,
					workforcePlanId,
					employeeId,
					workScaleGroup,

					payload: JSON.stringify({
						occurrenceJustification: occurrenceJustification,
						occurenceType: occurenceType,
						amountDays,
						occurenceDate
					}),
				} as FormFeedbackPayload;
			}
		}
	}

	private _getPayloadUpdateSolicitation() {
		switch (this.data.type) {
			case "REQUEST_TRAINING": {
				const {
					startTrainingDate,
					endTrainingDate,
					isApproved,
					changeTypeCode,
					hasDangerousness,
					unhealthinessType,
					newSalary,
					tradeUnionId
				} = this.form.value as RequestTrainingValues;

				const tradeUnionName = this._getTradeUnionTitleOption(tradeUnionId);

				return JSON.stringify({
					startTrainingDate,
					endTrainingDate,
					isApproved,
					changeTypeCode,
					hasDangerousness,
					unhealthinessType,
					newSalary: normalizeSalaryValue(newSalary),
					tradeUnionId,
					tradeUnionName
				});
			}
			case "REQUEST_APTITUDE_TRAINING": {
				const {
					startTrainingDate,
					endTrainingDate,
					isApproved,
				} = this.form.getRawValue() as RequestAptitudeTrainingValues;


				return JSON.stringify({
					startTrainingDate,
					endTrainingDate,
					isApproved,
				});
			}
			case "REQUEST_DISCIPLINARY_MEASURE": {
				const { occurrenceJustification } = this.form.getRawValue() as FormRequestDisciplinaryMeasure;

				const payload = {
					occurrenceJustification: occurrenceJustification
				};

				return JSON.stringify(payload);
			}
			case "REQUEST_FEEDBACK": {
				const { occurrenceJustification } = this.form.value as FormFeedback;

				const payload = {
					occurrenceJustification: occurrenceJustification
				};

				return JSON.stringify(payload);
			}
			case "REQUEST_DISMISSAL": {
                const { expectedDate } = this.form.getRawValue() as FormRequestDismissalValues;
                return JSON.stringify({ expectedDate });
            }
		}
	}

	private _getPayloadUpdateStatusSolicitation(status: number) {
		const formForPayload = this.getCurrentForm();
		const payloadString = this.getCurrentUpdatePayload();
		const payload = {
			note: this.justification,
			status,
			effectiveDate: formForPayload?.get('effectiveDate')?.value ?? this.data?.solicitation?.effectiveDate?.substring(0, 10),
			movementRequestId: this.data?.solicitation?.id,
			approvalScopeItemId: this.getCurrentApprovalScopeItemId(),
			movementRequestNote: this.canSelectOccurenceCodeAndUpdateJustification ? formForPayload?.get('note')?.value : "",
			payload: payloadString,
			customFields: this.getCustomFieldsPayload()
		} as SolicitationUpdateStatusData

		return payload;
	}

	private getCurrentApprovalScopeItemId(): string {
		return this.data?.solicitation?.approvalScopeItemId
			|| this.data?.solicitationDetails?.approvalScopeItemId
			|| "";
	}

	private async _loadHiddenStandardFields(runId?: number): Promise<void> {
		try {
			if (this._isStaleFormRun(runId)) {
				return;
			}

			if (this.data?.mode === 'details') {
				this.hiddenStandardFields = this.data?.solicitationDetails?.hiddenStandardFields || [];
				return;
			}

			this.hiddenStandardFields = [];
			const movementType = this.resolveCurrentMovementTypeId();
			if (!this.data?.type || !movementType) {
				return;
			}

			const hiddenFields = (await this._approvalScopeService
				.listHiddenStandardFieldsByMovementType(movementType, this.data?.companyId)
				.toPromise()) || [];
			if (this._isStaleFormRun(runId)) {
				return;
			}
			this.hiddenStandardFields = hiddenFields;
		} catch (error) {
			if (this._isStaleFormRun(runId)) {
				return;
			}
			console.error(error);
			this.hiddenStandardFields = [];
		} finally {
			if (!this._isStaleFormRun(runId)) {
				this.applyHiddenStandardFields();
			}
		}
	}

	private async _loadCustomFields(runId?: number): Promise<void> {
		if (this._isStaleFormRun(runId)) {
			return;
		}

		if (!this.data?.type) {
			this.customFieldsArray.clear();
			return;
		}

		this.customFieldsLoading = true;

		try {
			let fields: ApprovalScopeCustomFieldModel[] = [];

			if (this.data.mode === 'details') {
				fields = this.data?.solicitationDetails?.customFields || [];
			} else {
				const movementType = this.resolveCurrentMovementTypeId();
				if (movementType) {
					fields = await this._approvalScopeService
						.listMovementTypeCustomFields(movementType, this.data?.companyId)
						.toPromise();
				}
			}

			if (this._isStaleFormRun(runId)) {
				return;
			}

			this._rebuildCustomFieldsForm(fields || []);
		} catch (error) {
			if (this._isStaleFormRun(runId)) {
				return;
			}
			console.error(error);
			this._rebuildCustomFieldsForm([]);
		} finally {
			if (!this._isStaleFormRun(runId)) {
				this.customFieldsLoading = false;
			}
		}
	}

	private _rebuildCustomFieldsForm(fields: ApprovalScopeCustomFieldModel[]): void {
		const array = this._formBuilder.array(
			(fields || []).sort((a, b) => (a.order || 0) - (b.order || 0)).map(field => this._buildCustomFieldGroup(field))
		);

		this.customFieldsForm.setControl('customFields', array);

		if (this.areApprovalInputFieldsDisabled) {
			this.customFieldsForm.disable({ emitEvent: false });
		}
	}

	private _buildCustomFieldGroup(field: ApprovalScopeCustomFieldModel): UntypedFormGroup {
		const shouldUseArrayValue = [
			'MULTISELECT',
			'RADIO_OPTION_MULTISELECT',
		].includes(field.inputType);

		let initialValue: unknown = shouldUseArrayValue && field.value
			? field.value.split(',').map(value => value.trim()).filter(value => !!value)
			: field.value || (field.inputType === 'TRUE_OR_FALSE' ? null : '');

		if (field.inputType === 'NUMERIC' && field.value) {
			initialValue = normalizeSalaryValue(field.value);
		}

		const isReadOnly = !!field.readOnly;
		const shouldDisable = isReadOnly || this.areApprovalInputFieldsDisabled;
		const validators = !shouldDisable && field.required ? [Validators.required] : [];

		const group = this._formBuilder.group({
			customFieldId: [field.fieldId],
			key: [field.key],
			label: [field.label],
			inputType: [field.inputType],
			required: [field.required],
			readOnly: [isReadOnly],
			value: [{ value: initialValue, disabled: shouldDisable }, validators],
			options: [field.options || []],
		});

		return group;
	}

	private resolveCurrentMovementTypeId(): number | null {
		if (this.data?.type === 'EMPLOYEE_DETAILS') {
			return null;
		}

		if (this.data?.mode === 'details') {
			return this.data?.solicitation?.movementTypeData?.id
				|| (this.data?.solicitation?.movementType != null
					? Number(this.data.solicitation.movementType)
					: null);
		}

		const movementType = WorkforceplanMovementType.getByEnumerator(this.data?.type);
		return movementType?.id || null;
	}

	private hasInvalidEditableCustomFields(): boolean {
		return this.customFieldsArray.controls.some(control => {
			if (control.get('readOnly')?.value) {
				return false;
			}

			return control.invalid;
		});
	}

	private getCustomFieldsPayload() {
		const rawFields = this.customFieldsForm.getRawValue()?.customFields || [];

		return rawFields
			.filter((field: any) => !field.readOnly)
			.map((field: any) => ({
				customFieldId: field.customFieldId,
				key: field.key,
				label: field.label,
				value: this.normalizeCustomFieldValue(field.inputType, field.value),
			}))
			.filter((field: any) => !!field.customFieldId && field.value.trim() !== '');
	}

	private normalizeCustomFieldValue(inputType: string, rawValue: any): string {
		if (Array.isArray(rawValue)) {
			return rawValue.map(value => `${value}`.trim()).filter(value => !!value).join(', ');
		}

		if (rawValue === null || rawValue === undefined) {
			return '';
		}

		if (inputType === 'DATE') {
			if (rawValue instanceof Date) {
				return moment(rawValue).format('YYYY-MM-DD');
			}

			return `${rawValue}`.trim();
		}

		if (inputType === 'NUMERIC') {
			return formatSalaryForIntegration(rawValue);
		}

		return `${rawValue}`.trim();
	}

	public getDateFormated(value: string) {
		return moment(new Date(value)).utc(false).format('DD/MM/yyyy')
	}

	public getEffectiveDateFormated() {
		return this.getDateFormated(this.data?.solicitation?.effectiveDate)
	}

	public getColorIndicator(status: 'APPROVED' | 'REJECTED' | 'CANCELED' | 'NONE' | 'PENDING') {
		switch (status) {
			case 'APPROVED':
				return 'bg-success';
			case 'REJECTED':
				return 'bg-danger';
			case 'CANCELED':
				return 'bg-warning';
			case 'NONE':
			case 'PENDING':
				return 'bg-secondary';
			default:
				return 'bg-transparent';
		}
	}

	public getApprovalResponsible(step: WorkforcePlanSolicitationStepModel) {
		if (step.status === 'CANCELED') return 'CANCELADA';

		const isPending = !['APPROVED', 'REJECTED'].includes(step.status);
		if (isPending) return 'PENDENTE';

		return `${step.approverName ? `${step.approverName} - ${moment(step.effectiveDate).format('DD/MM/YYYY HH:mm')} 
			${step.approverJobTitleName ? `- ${step.approverJobTitleName}` : ''}` : ''}`;
	}

	private async _getSolicitationDetails() {
		const movementRequestId = this.data?.solicitation?.id;
		const approvalScopeItemId = this.data?.solicitation?.approvalScopeItemId
			|| this.data?.solicitationDetails?.approvalScopeItemId;

		if (!movementRequestId || !approvalScopeItemId) {
			return;
		}

		const shouldRefreshDetails =
			this.source !== 'action-required'
			|| !this.data?.solicitationDetails
			|| this.data?.solicitationDetails?.approvalScopeItemId !== approvalScopeItemId;

		if (!shouldRefreshDetails) {
			return;
		}

		const response = await this._workforceplanService
			.getWorkforcePlanSolicitationDetails(movementRequestId, approvalScopeItemId)
			.toPromise();

		this.data.solicitationDetails = response;
	}

	public get employeeSelected() {
		return this.form.value?.employee;
	}

	public get customFieldsArray(): FormArray {
		return this.customFieldsForm.get('customFields') as FormArray;
	}

	public isSelectableCustomField(inputType: string): boolean {
		return ['SELECT', 'RADIO_OPTION', 'TRUE_OR_FALSE'].includes(inputType);
	}

	public isMultiSelectableCustomField(inputType: string): boolean {
		return ['MULTISELECT', 'RADIO_OPTION_MULTISELECT'].includes(inputType);
	}

	public get isSolicitationPending() {
		return this.data?.solicitation?.status === 'PENDING'
	}

	public get canEditOptionApprovalTraining() {
		return (
			([this.DrawerTypes.REQUEST_TRAINING, this.DrawerTypes.REQUEST_APTITUDE_TRAINING].includes(this.data?.type)) &&
			this.data?.solicitationDetails?.hasStepActionType(
				ApprovalScopeActionType.SHOW_OPTION_TO_APPROVE_AND_FINISH_TRAINING.value
			)
		);
	}

	public get canEditTrainingCompletion() {
		if (!this.canEditOptionApprovalTraining) {
			return false;
		}

		const gate = this.data?.solicitationDetails?.trainingCompletionGate;
		if (gate?.isActive && !gate.canEdit) {
			return false;
		}

		return true;
	}

	public get isTrainingCompletionBlocked() {
		const gate = this.data?.solicitationDetails?.trainingCompletionGate;
		return !!(gate?.isActive && gate?.canEdit === false);
	}

	public get trainingCompletionBlockMessage() {
		return this.data?.solicitationDetails?.trainingCompletionGate?.blockMessage ?? '';
	}

	public get canSelectOccurenceCodeAndUpdateJustification() {
		return (
			this.data?.type === this.DrawerTypes.REQUEST_DISCIPLINARY_MEASURE &&
			this.data?.solicitationDetails?.hasStepActionType(
				ApprovalScopeActionType.SELECT_JUSTIFICATION_AND_UPDATE_NOTE.value
			)
		);
	}

	public get canEditFieldToStartTraining() {
		return (
			([this.DrawerTypes.REQUEST_TRAINING, this.DrawerTypes.REQUEST_APTITUDE_TRAINING].includes(this.data?.type)) &&
			this.data?.solicitationDetails?.hasStepActionType(
				ApprovalScopeActionType.SHOW_FIELD_TO_INDICATE_START_TRAINING.value
			)
		);
	}

	public get canShowFieldToStartTraining() {
		return this.canEditFieldToStartTraining || !!this.data?.solicitationDetails?.payloadData?.startTrainingDate;
	}

	public get canShowFieldToEndTraining() {
		return this.canEditOptionApprovalTraining || !!this.data?.solicitationDetails?.payloadData?.endTrainingDate;
	}

	public get canEditFieldToChangeJobTitleTrained() {
		return (
			this.data?.type === this.DrawerTypes.REQUEST_TRAINING &&
			this.data?.solicitationDetails?.hasStepActionType(
				ApprovalScopeActionType.SHOW_FIELDS_TO_APPROVE_NEW_JOBTITLE_TRAINED.value
			) && this.canExecute
		);
	}

	public get canShowFieldsToChangeJobTitleOrCostCenter() {
		if (this.data?.type !== this.DrawerTypes.REQUEST_TRAINING) return false;
		if (this.canEditFieldToChangeJobTitleTrained) {
			return true;
		}
		const payload = this.data?.solicitationDetails?.payloadData;
		return (
			!!(
				payload?.unhealthinessType ||
				payload?.hasDangerousness ||
				payload?.newSalary ||
				payload?.changeTypeCode
			) &&
			this._authService.hasActionAllowed(
				pagesActions.workforcePlan.canManageEmploymentContractInformation,
				"/workforceplan",
				true
			)
		);
	}

	public get canExecute() {
		return this.isSolicitationPending && this.data?.solicitationDetails?.permission?.canExecute;
	}

	public get areApprovalInputFieldsDisabled(): boolean {
		if (this.data?.mode !== 'details') {
			return false;
		}

		return !this.canExecute
			|| (this.canEditOptionApprovalTraining && this.isTrainingCompletionBlocked);
	}

	public get solicitationFiles(): MovementRequestFileModel[] {
		return this.data?.solicitationDetails?.files ?? [];
	}

	public get hasSolicitationFiles(): boolean {
		return this.solicitationFiles.length > 0;
	}

	public isFileLoading(fileId: string): boolean {
		return this.loadingFileIds.has(fileId);
	}

	public downloadMovementRequestFile(file: MovementRequestFileModel): void {
		const movementRequestId = this.data?.solicitation?.id;
		if (!movementRequestId || !file?.id || this.isFileLoading(file.id)) {
			return;
		}

		this.loadingFileIds.add(file.id);
		this._workforceplanMovementRequestService
			.downloadMovementRequestFile(movementRequestId, file.id)
			.pipe(take(1))
			.subscribe({
			next: (res: any) => {
				const fileContent = (res?.body ?? res) as FileContentModel;
				this._fileService.downloadBase64File(
					fileContent.encodedBase64,
					file.contentType || 'application/pdf',
					fileContent.fileName || file.fileName
				);
				this.toasterAbstract.showSuccess('Download do arquivo realizado com sucesso!');
			},
			error: () => {
				this.toasterAbstract.showWarning('Falha ao realizar download do arquivo!');
				this.loadingFileIds.delete(file.id);
			},
			complete: () => {
				this.loadingFileIds.delete(file.id);
			},
		});
	}

	public previewMovementRequestFile(file: MovementRequestFileModel): void {
		const movementRequestId = this.data?.solicitation?.id;
		if (!movementRequestId || !file?.id || this.isFileLoading(file.id)) {
			return;
		}

		this.loadingFileIds.add(file.id);
		this._workforceplanMovementRequestService
			.previewMovementRequestFile(movementRequestId, file.id)
			.pipe(take(1))
			.subscribe({
			next: (res: any) => {
				const fileContent = (res?.body ?? res) as FileContentModel;
				this._fileService.previewFileInNewWindow(
					file.contentType || 'application/pdf',
					fileContent.encodedBase64,
					fileContent.fileName || file.fileName
				);
			},
			error: () => {
				this.toasterAbstract.showWarning('Falha ao visualizar o arquivo!');
				this.loadingFileIds.delete(file.id);
			},
			complete: () => {
				this.loadingFileIds.delete(file.id);
			},
		});
	}

	public get isCurrentSolicitationFormValid(): boolean {
		const form = this.getCurrentForm();
		if (!form) {
			return true;
		}
		if (form.disabled) {
			return true;
		}
		return form.valid;
	}

	public get isDrawerSRequestWorkforcePlanDetails() {
		return this.data?.mode === 'details'
			&& this.data?.type === this.DrawerTypes.REQUEST_WORK_FORCEPLAN;
	}

	openTrainingModal() {
		const modalRef = this._modalService.open(WorkforcePlanModalComponent, {
			centered: true,
			keyboard: false,
			backdrop: "static",
			size: "lg",
			windowClass: "wfp-modal",
			backdropClass: "wfp-modal-backdrop"
		});
		modalRef.closed.subscribe(() => {
			this.loadTrainings();
		});
	}

	public get isAdmin() {
		return this._authService.isAdmin;
	}

	public get vacancyReplacement() {
		return this.getCurrentForm()?.value?.vacancyReplacement;
	}

	public get isSuspension(): boolean {
		return this.occurrenceTypeField.value === TypeOccurrenceDisciplinaryMeasure.Suspension.value;
	}

	public get showOccurrenceJustification() {
		return this.canSelectOccurenceCodeAndUpdateJustification || (this.occurrenceJustificationField && this.occurrenceJustificationField.value !== null)
	}

	public get occurrenceTypeField(): FormControl {
		return this.form.get("occurenceType") as FormControl;
	}

	public get occurrenceJustificationField(): FormControl {
		return this.form.get("occurrenceJustification") as FormControl;
	}

	public get amountDaysField(): FormControl {
		return this.form.get("amountDays") as FormControl;
	}

	public get startTrainingDate() {
		return this.form.get("startTrainingDate") as FormControl;
	}

	public get endTrainingDate() {
		return this.form.get("endTrainingDate") as FormControl;
	}

	public get newSalary() {
		return this.form.get("newSalary") as FormControl;
	}

	public get tradeUnionId() {
		return this.form.get("tradeUnionId") as FormControl;
	}

	public get changeTypeCode() {
		return this.form.get("changeTypeCode") as FormControl;
	}

	public get hasDangerousness() {
		return this.form.get("hasDangerousness") as FormControl;
	}

	public get unhealthinessType() {
		return this.form.get("unhealthinessType") as FormControl;
	}

	public get currentJobTitleName() {
		return this.form.get("currentJobTitleName") as FormControl;
	}

	public get executionDate() {
		return this.form.get("executionDate") as FormControl;
	}

	public get deadlineLabel(): boolean {
		const employeeId = this.form.get("employeeId")?.value;
		if (!employeeId) {
			return false;
		}
		const resignation = this.lists.employeesResignationsOptions.find(option => option.id === employeeId);
		return resignation?.status === 'APPROVED';
	}

	public get isJobtitleDisabled() {
		// Para REQUEST_HIRING_REPLACEMENT, verificar se já existe jobTitleId pre-definido
		if (this.data?.type === 'REQUEST_HIRING_REPLACEMENT') {
			return this.data?.employee?.jobTitleId && this.data?.employee?.jobTitleId !== guidEmpty;
		}
		// Para outros tipos, manter a lógica existente
		return this.form.value?.jobTitleId !== guidEmpty && this.data?.hasSubType;
	}

	public get employeeHasExtraInfo() {
		return !!(this.data?.employee?.costCenterName && this.data?.employee?.jobTitleName);
	}

	public get employeeContactDisplay(): string {
		return this._normalizeDisplayValue(this.data?.employee?.cellPhoneNumber);
	}

	public get emergencyNameDisplay(): string {
		return this._normalizeDisplayValue(this.data?.employee?.emergencyName);
	}

	public get emergencyKinshipDisplay(): string {
		return this._normalizeDisplayValue(this.data?.employee?.emergencyKinship);
	}

	public get emergencyPhoneDisplay(): string {
		return this._normalizeDisplayValue(this.data?.employee?.emergencyContact);
	}

	public get emergencyEmailDisplay(): string {
		return this._normalizeDisplayValue(this.data?.employee?.emergencyEmail);
	}

	public get hasEmergencyContactData(): boolean {
		return this._hasDisplayValue(this.data?.employee?.emergencyName)
			|| this._hasDisplayValue(this.data?.employee?.emergencyKinship)
			|| this._hasDisplayValue(this.data?.employee?.emergencyContact)
			|| this._hasDisplayValue(this.data?.employee?.emergencyEmail);
	}

	public getSelectedOptionText(options: OptionModel[] | any[], value: any): string | null {
		if (!options || !value || options.length === 0) {
			return null;
		}

		const selectedOption = options.find(option => {
			return option.value === value || option.label === value;
		});

		return selectedOption?.label || null;
	}

	private readonly sameAptitudeTrainingJobTitleValidator: ValidatorFn = (control) => {
		if (this.data?.mode !== "add" || this.data?.type !== this.DrawerTypes.REQUEST_APTITUDE_TRAINING) {
			return null;
		}

		return this.isSameAptitudeTrainingDestinationJobTitle(control.value) ? { sameJobTitle: true } : null;
	};

	private isSameAptitudeTrainingDestinationJobTitle(destinationJobTitleId?: string | null): boolean {
		if (this.data?.type !== this.DrawerTypes.REQUEST_APTITUDE_TRAINING) {
			return false;
		}

		const employeeJobTitleId = this.data?.employee?.jobTitleId;
		const selectedJobTitleId = destinationJobTitleId ?? this.form?.get("jobTitleId")?.value;
		return !!employeeJobTitleId
			&& employeeJobTitleId !== guidEmpty
			&& !!selectedJobTitleId
			&& selectedJobTitleId !== guidEmpty
			&& selectedJobTitleId === employeeJobTitleId;
	}

	private warnIfSameAptitudeTrainingJobTitle(destinationJobTitleId?: string | null): boolean {
		if (!this.isSameAptitudeTrainingDestinationJobTitle(destinationJobTitleId)) {
			return false;
		}

		this.toasterAbstract.showWarning(
			"Não é possível criar uma solicitação de treinamento para a mesma função do colaborador."
		);
		return true;
	}

	private _normalizeDisplayValue(value: unknown, fallback = '-'): string {
		if (value === null || value === undefined) {
			return fallback;
		}

		const normalized = String(value).trim();
		if (!normalized) {
			return fallback;
		}

		const lower = normalized.toLowerCase();
		if (lower === 'false' || lower === 'null' || lower === 'undefined') {
			return fallback;
		}

		return normalized;
	}

	private _hasDisplayValue(value: unknown): boolean {
		return this._normalizeDisplayValue(value, '') !== '';
	}

	private _formatPhoneSafe(value: unknown): string {
		const normalized = this._normalizeDisplayValue(value, '');
		return normalized ? formattedPhone(normalized) : '';
	}

	public onOpeningInstructionsDismissed(): void {
		this.showOpeningInstructionsBanner = false;
	}

	private _loadStepInstructionsBanner(): void {
		const movementTypeId = this.resolveCurrentMovementTypeId();
		const approvalScopeItemId = this.getCurrentApprovalScopeItemId();

		if (this.data?.mode === 'details' && approvalScopeItemId) {
			this._fetchAndApplyStepInstructions({ approvalScopeItemId });
			return;
		}

		if (this.data?.mode !== 'add') {
			this.showStepInstructionsBanner = false;
			return;
		}

		const companyId = this.data?.companyId;
		if (!companyId || movementTypeId == null) {
			this.showStepInstructionsBanner = false;
			return;
		}

		this._fetchAndApplyStepInstructions({
			companyId,
			movementType: movementTypeId,
			sequence: 1,
		});
	}

	private _fetchAndApplyStepInstructions(
		params: Parameters<ApprovalScopeService['getStepInstructionsContext']>[0]
	): void {
		this._approvalScopeService
			.getStepInstructionsContext(params)
			.toPromise()
			.then(context => this._applyStepInstructionsContext(context))
			.catch(() => {
				this.showStepInstructionsBanner = false;
			});
	}

	private _applyStepInstructionsContext(
		context: ApprovalScopeStepInstructionsContextModel | null | undefined
	): void {
		if (!context?.shouldShow || !context?.stepInstructions?.trim()) {
			this.showStepInstructionsBanner = false;
			this.stepInstructionsText = '';
			return;
		}

		this.stepInstructionsText = context.stepInstructions.trim();
		this.showStepInstructionsBanner = true;
	}

	private _isCostCenterChangeAdd(): boolean {
		return this.data?.mode === "add"
			&& this.data?.type === this.DrawerTypes.COST_CENTER_AND_JOB_TITLE_CHANGE;
	}

	private _isRestrictedCostCenterChangeAdd(): boolean {
		return this._isCostCenterChangeAdd() && !this.data?.hasSubType;
	}

	private _isStaleFormRun(runId?: number): boolean {
		return runId != null && runId !== this._initializeFormRunId;
	}

	private _markDrawerFetched(runId: number): boolean {
		if (this._isStaleFormRun(runId)) {
			return false;
		}

		this.drawerStatus = "fetched";
		return true;
	}

	private _blockCostCenterChangeForMissingContext(): void {
		this.canChangeToDifferentCostCenter = false;
		this.openingInstructionsContextFailed = true;
	}

	private _loadOpeningInstructionsBanner(): Promise<void> {
		const requestId = ++this._openingContextRequestId;
		this.canChangeToDifferentCostCenter = true;
		this.openingInstructionsContextFailed = false;
		this.showOpeningInstructionsBanner = false;

		if (this.data?.mode !== 'add') {
			return Promise.resolve();
		}

		const companyId = this.data?.companyId;
		const movementTypeId = this.resolveCurrentMovementTypeId();

		if (!companyId || movementTypeId == null) {
			if (this._isRestrictedCostCenterChangeAdd()) {
				this._blockCostCenterChangeForMissingContext();
			}
			return Promise.resolve();
		}

		return this._approvalScopeService
			.getOpeningInstructionsContext(companyId, movementTypeId)
			.toPromise()
			.then(context => {
				if (requestId !== this._openingContextRequestId) {
					return;
				}

				this.canChangeToDifferentCostCenter = context?.canChangeToDifferentCostCenter !== false;

				if (!context?.shouldShow || !context?.openingInstructions?.trim()) {
					return;
				}

				this.openingInstructionsText = context.openingInstructions.trim();
				this.openingInstructionsApprovalScopeId = context.approvalScopeId || '';
				this.openingInstructionsCanHidePreference = context.canHidePreference;
				this.showOpeningInstructionsBanner = true;
			})
			.catch(() => {
				if (requestId !== this._openingContextRequestId) {
					return;
				}

				if (!this._isRestrictedCostCenterChangeAdd()) {
					return;
				}

				this._blockCostCenterChangeForMissingContext();
			});
	}
}
